import datepicker from 'js-datepicker'
import SortFunction from 'packs/sortable/sort_function'
export default class Task {
  showUpdatePersonInChargeSuccessPopup() {
    Popup.alert('メンバーを更新しました。', '', '', {
      timer: 3000,
      allowOutsideClick: false,
      allowEscapeKey: false
    })
  }

  async delete(projectId, taskId, taskName) {
    let isEffortNotReleased = await this.checkDeleteTask(projectId, taskId)
    this.handleDelete(
      Routes.owner_destroy_task_path(projectId, taskId), projectId, taskName, taskId, isEffortNotReleased
    )
  }

  async popupDeleteTask(elementText, projectId, taskId, taskName) {
    const element = $(document).find(`#${elementText}`)
    const modalComponent = $(element).parents('div#exampleModalCenter')
    const url = Routes.owner_project_task_show_modal_delete_task_child_path(projectId, taskId)
    await Shared.callAjax(url, {}, 'html').done(function(data) {
      $('#show-content-modal').html(data)
      modalComponent.modal('show')
    })
    .fail(function(data) {
      modalComponent.modal('hide')
      Popup.alert(I18n.t('shared.one_error_please_try_again'));
    })
  }

  async deleteTaskWithPopup(element, projectId, taskId, taskName) {
    const modalEle = $(element).parents('.modal-content');
    const deleteAll = modalEle.find('.modal-body').find('input:checked').val();
    let isEffortNotReleased = await this.checkDeleteTask(projectId, taskId, deleteAll)
    this.handleDelete(
      Routes.owner_destroy_task_path(projectId, taskId, {delete_all: deleteAll}),
      projectId, taskName, taskId, isEffortNotReleased
    )
  }

  handleDelete(url, projectId, taskName, taskId, isEffortNotReleased) {
    const task = this
    if (isEffortNotReleased) {
      const urlEffort = Routes.undelivered_works_efforts_path({ task_id: taskId })
      const urlEffortNotReleased =
        Routes.deleted_works_efforts_path({search_kind: 'task_delete_id_cont', q: { kind_id: taskId } })
      Popup.confirm('', {
        description: `
        <div>
          <div class="text-center">未納品作業が存在します。 </div><br>
          <span>
            タスクを削除すると、関連書類及び未納品作業データ以外は全て削除されます。<br>
            <a class="text-underline font-weight-bold" target="_blank" href="${urlEffort}">未納品作業一覧ページ</a>より未納品作業をご確認の上、削除を行ってください。<br>
            タスク削除後、10日間は<a class="text-underline font-weight-bold" target="_blank" href="${urlEffortNotReleased}">削除一覧ページ</a>より未納品作業のStatus変更が可能です。<br>
            タスク削除後、10日を超過すると未納品作業のStatus変更は出来ません。 <br>
            ※タスクと紐づいている書類は削除されません。書類管理から削除できます。
          </span>
        </div>
      `,
        confirmText: '削除する',
        width: '40rem',
        success: () => {
          task.successDeleteTask(task, projectId, url, taskId)
        }
      })
    } else {
      Popup.confirm(`「${taskName}」タスクを削除します。<br>タスクを削除すると、タスク内の全てのデータが削除され復元できません。<br>「${taskName}」タスクを削除してよろしいですか？`, {
        confirmText: 'OK',
        success: () => {
          task.successDeleteTask(task, projectId, url, taskId)
        }
      })
    }
  }

  successDeleteTask(taskModel, projectId, url, taskId) {
    Shared.callAjax(url, {}, 'json', 'delete')
    .done(function(data) {
      taskModel.reloadWithDeleteTask(projectId, taskId)
    })
    .fail(function(data) {
      Popup.alert(data.responseJSON.message)
    })
  }

  reloadWithDeleteTask(projectId, taskId) {
    const row = $('#sortable-' + taskId)
    const children = $('.sortable-' + taskId)
    row.add(children).fadeOut(200, function() { $(this).remove() })
    $('#thumb-task-' + taskId + ', #thumb-task-sp-' + taskId).fadeOut(200, function() { $(this).remove() })
  }

  async checkDeleteTask(projectId, taskId, isDeleteAll = false) {
    const url = Routes.owner_project_task_check_delete_task_path(projectId, taskId, { is_delete_all: isDeleteAll })
    let isEffortNotReleased = false
    await Shared.callAjax(url, {}).done(function(data) {
      isEffortNotReleased = data.status
    })
    return isEffortNotReleased
  }

  toggleTaskChilds(element, taskId, taskChildIds) {
    Collapsible.toggle($(element), Task._closeTaskCallback(taskChildIds))
    Visiable.toggle(`.task_parent_${taskId}`)
  }

  toggleWorks(element) {
    let taskId = $(element).attr('task_id')
    Visiable.toggle(`.task_${taskId}`)
  }

  disabledDeleteAll(element, isConfirm) {
    if (isConfirm !== 'true' || !$(element).is(':checked')) return
    $(element).parents('.modal-content').find('.confirm-delete-task').attr('disabled', $(element).val() === 'true')
  }

  copy(taskId) {
    const projectId = $('#projectId').val();
    const taskComponent = $(`#copyTaskModal-${taskId}`);
    const url = Routes.owner_project_task_copy_path(projectId, taskId)
    Shared.callAjax(url, {}).done((data) => {
      Task._renderTaskCopy(data.task, taskComponent, data.users, data.attachments, data.source_task_name);
      taskComponent.modal('show');
    }).fail((data) => {
      Popup.alert(I18n.t('shared.one_error_please_try_again'));
    })
  }

  getCompany(element, is_has_client) {
    var type_text = {
      owners: { type: 'owner', text: 'チーム' },
      suppliers: { type: 'supplier', text: '仕入先' },
      clients: { type: 'client', text: '販売先' },
      collaborators: { type: 'collaborator', text: '外部' }
    }
    const company_type = $(element).val();
    InviteUserShare.updateCompanyTypeText(company_type)
    if (company_type === '') {
      $(element).parents('div.modal-body').find('#inviteAdd').addClass('disabled');
      return
    }

    $('.company-type-text').text(type_text[company_type].text);

    if (company_type === 'clients' && is_has_client === 'false') {
      Popup.alert(
        '販売先は「プロジェクト」から招待できます。<br>「権限一括設定」または「プロジェクト一覧＞メンバー」<br>から招待してください。'
      )
      $('#show-selected-company-type').empty();
      $('#js_select_company_invites_task').empty()
      $(element).val('').trigger('change')
      return
    }

    $('#js_select_company_invites_task').empty()
    if (company_type !== 'owners') {
      $('#inviteExistUserByEmail').find('#permission_type').val(type_text[company_type].type)
      if (!$('#select_current_company').hasClass('d-none')) $('#select_current_company').addClass('d-none')
      $('#select_company_by_type').removeClass('d-none')
      $('#button_add_new_member').addClass('d-none')
    } else {
      $('#select_current_company').removeClass('d-none')
      $('#select_company_by_type').addClass('d-none')
      $('#button_add_new_member').removeClass('d-none')
    }
    if(company_type === 'clients' && is_has_client === 'true') {
      $('#select_company_by_type').find('.btn-mint-absolute').addClass('d-none')
    } else {
      $('#select_company_by_type').find('.btn-mint-absolute').removeClass('d-none')
    }
    const projectId = $(element).attr('project_id');
    const workId = $('#addPersonInChargeOfObject').data('work-id')
    $('#button_add_member_of_partner').addClass('d-none')
    $('#button_add_new_by_email').removeClass('d-none')
    $('#js-select_users_invites').empty();
    this._handleFetchData(
      Routes.owner_get_company_by_task_path(projectId), { 'company_type': company_type, work_id: workId }
    ).then(() => {
      $('#js_select_company_invites_task').val($("#js_select_company_invites_task option:last").val()).trigger('change')
    });
  }

  removeDisabledBtnInvite(element) {
    const modalEle = $(element).parents('div.modal-body');
    const userSelect = modalEle.find('#js-select_users_invites').val()
    if (userSelect && userSelect !== '') {
      $(element).parents('div.modal-body').find('#inviteAdd').removeClass('disabled');
    } else {
      $(element).parents('div.modal-body').find('#inviteAdd').addClass('disabled');
    }
  }

  changeUserOfaddMemberListTask(ele) {
    if ($(ele).val() === '') {
      $(ele).parents('div.modal-body').find('#inviteAdd').addClass('disabled');
    } else if($(ele).val() === 'invite_partner_member') {
      $(ele).parents('div.modal-body').find('.invite-member-of-partner-button').trigger('click');
    } else if($(ele).val() === 'invite_member') {
      $('#button_add_new_member').find('.btn-mint').trigger('click');
    } else {
      this.removeDisabledBtnInvite($(ele))
    }
  }

  fetchUserInvite(element) {
    if ($(element).val() === '') {
      $(element).parents('div.modal-body').find('#inviteAdd').addClass('disabled');
      return
    } else if ($(element).val() === 'invite_company') {
      $(element).closest('#select_company_by_type').find('.btn.btn-mint').trigger('click');
      return;
    }

    const companyId = $(element).val();
    const projectId = $('#projectId').val();
    const companyType = InviteUserShare.getCompanyType(element);
    InviteUserShare.updateCompanyTypeText(companyType)
    let exceptUserIds = JSON.parse($('#inviteLists .list-user-invite-task').val() || $('.list-user-invite-task').first().val() || '[]').map(Number);
    const unSubmitValues = [];
    $('#personInChargeOfObject .show-list-member-for-page[is-new-add="true"] input.pick-pics').map(function () {
      const v = Number(this.value);
      if (!Number.isNaN(v)) unSubmitValues.push(v);
    });
    exceptUserIds = exceptUserIds.filter(v => !unSubmitValues.includes(v));
    if(companyType == 'owners') {
      $('#button_add_member_of_partner').addClass('d-none')
      $('#button_add_new_member').removeClass('d-none')
    } else {
      $('#button_add_member_of_partner').removeClass('d-none')
      $('#button_add_new_member').addClass('d-none')
    }

    $('#inviteExistUserByEmail').find('#company_id').val(companyId)
    const data = { 'company_id': companyId, 'company_type': companyType }
    this._handleFetchData(Routes.owner_get_user_of_task_path(projectId), data, 'users', exceptUserIds, unSubmitValues).then(() => {
      InviteUserShare.disableInvitedUserOptions('#js-select_users_invites')
      this.buildMemberInviteTable()
    });
  }

  removeAttachment(element) {
    const attachmentOuter = $(element).closest('.attachment_outer');
    const id = attachmentOuter.find('.attachment').attr('data-id');
    attachmentOuter.hide(500);
    if($('#delete_attachment').val()){
      $('#delete_attachment').val(`${$('#delete_attachment').val()}, ${id}`)
    }else{
      $('#delete_attachment').val(id)
    }
    this.submitEditTaskDetail()
  }

  async create(element) {
    const form = this._resolveTaskForm(element);
    const isError = await this._validateTask(form);
    if (isError) return
    form.submit();
    $(element).attr('disabled', true);
  }

  openAddPicModal(resetValues = false) {
    if (resetValues) {
      if ($('#js_select_company_type_task').length > 0) {
        $('#js_select_company_type_task').val('');
        $('#js_select_company_invites_task').empty();
        $('#js-select_users_invites').empty();
        $('#button_add_new_by_email').addClass('d-none')
        $('#button_add_member_of_partner').addClass('d-none')
        $('#button_add_new_member').addClass('d-none')
        $('#select_company_by_type').removeClass('d-none')
        $('#select_current_company').addClass('d-none')
      } else {
        $('#js_select_company_invites_task').val('');
        $('#js-select_users_invites').empty();

        if($('#current_company_id').length > 0) {
          this.fetchUserInvite('#current_company_id');
          $('#button_add_new_member').removeClass('d-none')
        } else {
          $('#button_add_member_of_partner').addClass('d-none')
        }
      }
      $('#add_new_email_permission').val('');
      $('#add_new_email_permission_type').val('')
    }

    if($('#js-select_users_invites').val() == 'invite_member') {
      $('#js-select_users_invites').val('');
    }

    if ($('#js_select_company_type_task').length > 0 && $('#js_select_company_invites_task').val() == 'invite_company') {
      $('#js_select_company_invites_task').val('');
    }
    var tastName = $("#personInChargeOfObject").find('.task_name_header').text()
    const dataIsShow = $("#personInChargeOfObject").attr('data-is-show')
    if (dataIsShow === 'true') {
      $("#addPersonInChargeOfObject").attr('data-is-show-popup', 'true')
    }
    $("#personInChargeOfObject").attr('data-is-show', 'false');
    $('#addPersonInChargeOfObject').attr('data-is-back-list-member', 'true');
    $("#personInChargeOfObject").modal("hide")
    $("#inviteByEmail").modal("hide")
    $("#inviteExistUserByEmail").modal("hide")
    $("#addPersonInChargeOfObject").find('.task_name_header').html(tastName)
    Shared.appendSelect2('#addPersonInChargeOfObject', '#js_select_company_invites_task', 'アカウント名を選択してください', 'アカウント名を検索', null, InviteUserShare.removeCompanyPrefixSuffix, InviteUserShare.formatCompanyOptionWithIcon)
    Shared.appendSelect2('#addPersonInChargeOfObject', '#js_select_company_type_task', '取引種類を選択してください', '', InviteUserShare.customOptionCompanyType, InviteUserShare.removeCompanyPrefixSuffix)
    Shared.appendSelect2('#addPersonInChargeOfObject', '#js-select_users_invites', 'メンバー名を選択してください', 'メンバー名を検索', null)
    $('#addPersonInChargeOfObject').find('#js_select_company_invites_task')
      .val($('#addPersonInChargeOfObject').find('#js_select_company_invites_task option[data-type="owners"]').val())
      .trigger('change')
    $('#js_select_company_invites_task, #js-select_users_invites').off('select2:open.maxRows').on('select2:open.maxRows', function () {
      setTimeout(function () {
        $('#addPersonInChargeOfObject .select2-results__options').css('cssText', 'max-height: 320px !important')
      }, 0)
    })
    $("#addPersonInChargeOfObject").modal("show")
  }

  repaginateMemberList() {
    try {
      const modalEle = document.getElementById('personInChargeOfObject');
      if (!modalEle) return;
      const perPage = 10;
      const allRows = Array.from(modalEle.querySelectorAll('div.show-list-member-for-page'));
      const newRows = allRows.filter(tr => tr.getAttribute('is-new-add') === 'true');
      const rows = allRows.filter(tr => tr.getAttribute('is-new-add') !== 'true');
      newRows.forEach(tr => {
        tr.setAttribute('data-page', 1);
        tr.style.setProperty('display', 'flex', 'important');
      });
      rows.forEach((tr, index) => {
        const page = Math.floor(index / perPage) + 1;
        tr.setAttribute('data-page', page);
        tr.style.setProperty('display', page === 1 ? 'flex' : 'none', 'important');
      });
      const totalPages = Math.max(1, Math.ceil(rows.length / perPage));
      const ul = modalEle.querySelector('#render-list-pagynate-of-member-project-author ul.pagination');
      if (!ul) return;
      let html = '';
      for (let i = 1; i <= totalPages; i++) {
        const active = i === 1 ? ' active' : '';
        html += '<li class="option page-item' + active + '" data-index="' + i + '" onclick="TaskPic.selectPage(this)"><span class="page-link">' + i + '</span></li>';
      }
      ul.innerHTML = html;
      if (TaskPic.updateMemberPaginationWindow) TaskPic.updateMemberPaginationWindow($(ul));
    } catch (e) { console.error('repaginate error', e); }
  }

  buildMemberInviteTable() {
    if (!document.getElementById('memberInviteTableBlock')) return;
    const opts = $('#js-select_users_invites option').toArray()
      .filter(o => o.value && o.value !== 'invite_member' && o.value !== 'invite_partner_member');
    this._mtAll = opts.map(o => ({ id: String(o.value), text: o.text, disabled: o.disabled }));
    this._mtChecked = new Set();
    // 一覧(pics-table)で✓済みの本人(この会社の子分等)を、招待モーダルの表に「選択済み・グレー・外せない」で補完(プロジェクト1d00ef94cと同型/候補生成は不変/DOMはタスク仕様)
    try {
      const __selCid = String($('#js_select_company_invites_task :selected').val() || '');
      const __ids = new Set(this._mtAll.map(u => u.id));
      $('#personInChargeOfObject .pics-table input.pick-pics:checked').each((_, el) => {
        const $el = $(el);
        const uid = String($el.attr('data-user-id') || $el.val() || '');
        if (!uid) return;
        if (!__selCid) return;
        if (String($el.attr('data-company-id') || '') !== __selCid) return;
        if (!__ids.has(uid)) {
          const nm = ($el.closest('.show-list-member-for-page').find('.t_name').text() || '')
            .replace(/\s+/g, ' ').trim() || uid;
          this._mtAll.push({ id: uid, text: nm, disabled: true });
          __ids.add(uid);
        }
        this._mtChecked.add(uid);
      });
    } catch (e) {}
    this._mtQuery = '';
    this._mtPage = 1;
    $('#mtSearchInput').val('');
    $('#memberInviteTableBlock').removeClass('d-none');
    this.renderMemberInviteTable();
  }

  _mtFiltered() {
    const q = (this._mtQuery || '').toLowerCase();
    return (this._mtAll || []).filter(u => u.text.toLowerCase().includes(q));
  }

  renderMemberInviteTable() {
    const list = this._mtFiltered();
    const perPage = 10;
    const totalPages = Math.max(1, Math.ceil(list.length / perPage));
    if (this._mtPage > totalPages) this._mtPage = totalPages;
    if (this._mtPage < 1) this._mtPage = 1;
    const pageItems = list.slice((this._mtPage - 1) * perPage, (this._mtPage - 1) * perPage + perPage);
    const esc = (t) => $('<div>').text(t).html();
    let html = '';
    pageItems.forEach(u => {
      const mark = this._mtChecked.has(u.id) ? '✓' : '';
      const tdStyle = u.disabled ? 'color:#999;' : '';
      const cellExtra = u.disabled ? 'pointer-events:none;background:#f5f5f5;' : 'cursor:pointer;';
      const stripe = u.disabled ? 'background:#f5f5f5;' : 'background:#fff;';
      html += `<tr style="height:32px;border-bottom:1px solid #e2e2e2;${stripe}">` +
        `<td onclick="Task.checkMemberInviteRow(this)" data-id="${u.id}" style="text-align:center;border-right:1px solid #e2e2e2;${cellExtra}"><span style="color:#c00;font-weight:bold;font-size:18px;line-height:1;">${mark}</span></td>` +
        `<td style="padding:2px 8px 2px 5px !important;text-align:left !important;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;${tdStyle}">${esc(u.text)}</td></tr>`;
    });
    for (let i = pageItems.length; i < perPage; i++) {
      const stripe = 'background:#fff;';
      html += `<tr style="height:32px;border-bottom:1px solid #e2e2e2;${stripe}"><td style="border-right:1px solid #e2e2e2;">&nbsp;</td><td></td></tr>`;
    }
    $('#mtBody').html(html);
    let p = '';
    if (totalPages > 1) {
      for (let i = 1; i <= totalPages; i++) {
        const active = i === this._mtPage ? 'background:#1d2b50;color:#fff;' : 'background:#fff;color:#1d2b50;';
        p += `<button type="button" onclick="Task.gotoMemberInvitePage(${i})" style="min-width:28px;height:26px;border:1px solid #1d2b50;border-radius:4px;cursor:pointer;${active}">${i}</button>`;
      }
    }
    $('#mtPagination').html(p);
    const enabled = list.filter(u => !u.disabled);
    const allChecked = enabled.length > 0 && enabled.every(u => this._mtChecked.has(u.id));
    $('#mtCheckAll').text(allChecked ? '✓' : '').attr('data-checked', allChecked ? 'true' : 'false');
    const btn = $('#addPersonInChargeOfObject').find('#inviteAdd');
    if (this._mtChecked && this._mtChecked.size > 0) btn.removeClass('disabled'); else btn.addClass('disabled');
  }

  searchMemberInviteTable(ele) {
    this._mtQuery = $(ele).val();
    this._mtPage = 1;
    this.renderMemberInviteTable();
  }

  gotoMemberInvitePage(page) {
    this._mtPage = page;
    this.renderMemberInviteTable();
  }

  checkMemberInviteRow(ele) {
    const id = String($(ele).data('id'));
    if (this._mtChecked.has(id)) this._mtChecked.delete(id); else this._mtChecked.add(id);
    this.renderMemberInviteTable();
  }

  toggleAllMemberInviteTable(ele) {
    const list = this._mtFiltered().filter(u => !u.disabled);
    const willCheck = $(ele).attr('data-checked') !== 'true';
    if (willCheck) list.forEach(u => this._mtChecked.add(u.id));
    else list.forEach(u => this._mtChecked.delete(u.id));
    this.renderMemberInviteTable();
  }

  openAddMemberFromTable() {
    if (!$('#button_add_member_of_partner').hasClass('d-none')) {
      $('#button_add_member_of_partner').find('button').trigger('click');
    } else {
      $('#button_add_new_member').find('button').trigger('click');
    }
  }

  cancelMemberInviteTable(event) {
    this._mtChecked = new Set();
    this.closeAddPersonInChargeOfObject();
  }

  inviteCheckedMembers(element, confirmed = false) {
    if (!this._mtChecked || this._mtChecked.size === 0) return;
    const isFileModal = $('#personInChargeOfObject').attr('data-akaire-file-id') || $('#personInChargeOfObject .tm-file-header-title-text').text().includes('ファイル');
    if (!confirmed && !isFileModal) {
      let invited = [];
      try { invited = JSON.parse($('#project-invited-user-ids').val() || '[]').map(String); } catch (e) {}
      const hasUninvited = Array.from(this._mtChecked).some(id => !invited.includes(String(id)));
      if (hasUninvited) {
        Popup.confirm('プロジェクトに招待されていないメンバーを<br>タスクに招待すると、限定メンバーとなり、<br>このタスク配下のすべてのファイルのみに自動で招待されます。', {
          confirmText: 'OK',
          cancelBtn: 'true',
          success: () => { this.inviteCheckedMembers(element, true); },
          cancel: () => {}
        });
        return;
      }
    }
    const inviteLists = $('#inviteLists');
    let listUserInvite = JSON.parse(inviteLists.find('.list-user-invite-task').val() || '[]');
    const companyId = $('#js_select_company_invites_task :selected').val();
    const actionOnclick = 'Task.deleteUserInvite(this)';
    const isTeam = $('#js_select_company_invites_task option:selected').data('type') === 'owners';
    const iconColor = isTeam ? '#E24B4A' : '#888780';
    const iconTitle = isTeam ? 'チーム' : '外部';
    const icon = `<span class="member-type-icon" title="${iconTitle}" style="display:inline-flex;align-items:center;justify-content:center;width:24px;height:24px;min-width:24px;border-radius:50%;background:${iconColor};vertical-align:middle;margin-right:4px;"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="4"/><path d="M5 21v-1a7 7 0 0 1 14 0v1"/></svg></span>`;
    const nameMap = {};
    (this._mtAll || []).forEach(u => { nameMap[u.id] = u.text; });
    Array.from(this._mtChecked).forEach(id => {
      const userName = nameMap[id];
      if (!userName) return;
      const existing = $('#personInChargeOfObject').find(`input[value="${id}"]`);
      if (existing.length) {
        if (!existing.is(':checked')) existing.parent().click();
      } else {
        const elementAdd = `<div class="tr d-flex show-list-member-for-page" is-showed="true" is-new-add="true">` +
          `<div class="td t_invite cursor-pointer" onclick="TaskPic.handleCheckAction(this)">` +
          `<input type="checkbox" name="pic" id="pic" value="${id}" class="pick-pics d-none" checked>` +
          `<div class="check-view check-red"></div></div>` +
          `<div class="td d-flex t_name">${icon}<p>${userName}</p></div></div>`;
        $('#personInChargeOfObject').find('.pics-table').append(elementAdd);
        this.showEleFilterNewAdd($('#personInChargeOfObject').find(`input[value="${id}"]`));
        this.repaginateMemberList();
      }
      inviteLists.find('.invite_lists_inner').append(`<span class="invite_name" data-flag="new_permission_task" data-companyid="${companyId}" data-inviteid="${id}" onclick="${actionOnclick}">${userName}</span>`);
      inviteLists.find('.view_box_lists').append(`<li class="dropdown-item" onclick="${actionOnclick}" data-flag="new_permission_task" data-companyid="${companyId}" data-inviteid="${id}"><span>${userName}</span><i data-feather="x-square" class="invite_delete"></i></li>`);
      listUserInvite.push(id);
      $('#js-select_users_invites').find(`option[value="${id}"]`).remove();
      const idAddUserInvite = $('#idAddUserInvite').val() || '';
      if (idAddUserInvite.length > 0) { $('#idAddUserInvite').val(`${idAddUserInvite},${id}`); } else { $('#idAddUserInvite').val(id); }
    });
    inviteLists.find('.list-user-invite-task').val(`[${listUserInvite}]`);
    $('#personInChargeOfObject').attr('data-is-change', 'true');
    $('#personInChargeOfObject').attr('data-is-show', 'true');
    $('#personInChargeOfObject').modal('show');
    $('#addPersonInChargeOfObject').modal('hide');
    $('#invite-table-notice-text').empty();
    this._mtChecked = new Set();
  }

  addUserInvite(element, isAkapon) {
    const types = { owners: '自社', suppliers: '仕入先', clients: '販売先', collaborators: '外部' }
    const inviteUser = $('#js-select_users_invites').val();
    const inviteLists = $('#inviteLists');
    let listUserInvite = JSON.parse(inviteLists.find('.list-user-invite-task').val())
    const userName = $('#js-select_users_invites option:selected').text()
    const companyId = $('#js_select_company_invites_task :selected').val();
    const companyName = $(element).parent().find("#js_select_company_invites_task option:selected").text()
    const actionOnclick = `Task.deleteUserInvite(this)`
    const idAddUserInvite = $('#idAddUserInvite').val()

    if(inviteUser){
      var elementAdd = `<div class="tr d-flex show-list-member-for-page" is-showed="true" is-new-add="true">
                <div class="td t_invite cursor-pointer" onclick="TaskPic.handleCheckAction(this)">
                  <input type="checkbox" name="pic" id="pic" value="${inviteUser}" class="pick-pics d-none" checked>
                  <div class="check-view check-red"></div>
                </div>
                <div class="td d-flex t_name">
                  ${icon}<p>${userName}</p>
                </div>
              </div>`

      if($("#personInChargeOfObject").find(`input[value="${inviteUser}"]`).length) {
        $("#personInChargeOfObject").find(`input[value="${inviteUser}"]`).parent().click()
      } else {
        $("#personInChargeOfObject").find(".pics-table").append(elementAdd)
        this.showEleFilterNewAdd($("#personInChargeOfObject").find(`input[value="${inviteUser}"]`))
        this.repaginateMemberList()
      }
      $("#personInChargeOfObject").attr('data-is-change', 'true')

      $("#personInChargeOfObject").attr('data-is-show', 'true')
      $("#personInChargeOfObject").modal("show")
      $("#addPersonInChargeOfObject").modal("hide")
      inviteLists.find('.invite_lists_inner').append(`<span class="invite_name" data-flag="new_permission_task" data-companyid="${companyId}" data-inviteid="${inviteUser}" onclick="${actionOnclick}">${userName}</span>`);
      const elementAdd_tmp = `<li class="dropdown-item" onclick="${actionOnclick}" data-flag="new_permission_task" data-companyid="${companyId}" data-inviteid="${inviteUser}"><span>${userName}</span><i data-feather="x-square" class="invite_delete"></i></li>`;
      inviteLists.find('.view_box_lists').append(elementAdd_tmp);
      listUserInvite.push(inviteUser)
      inviteLists.find('.list-user-invite-task').val(`[${listUserInvite}]`)
      $('#js-select_users_invites').find(`option[value="${inviteUser}"]`).remove();

      if(idAddUserInvite.length > 0){
        $('#idAddUserInvite').val(`${idAddUserInvite},${inviteUser}`)
      }else{
        $('#idAddUserInvite').val(inviteUser)
      }

      $('#invite-table-notice-text').empty();
    }
  }

  deleteUserInvite(element) {
    const inviteId = $(element).data('inviteid');
    const inviteLists = $('#inviteLists')
    const inputProjectAndTask = $('#project_id_and_task_id');
    const projectId = inputProjectAndTask.attr('project_id');
    const taskId = inputProjectAndTask.attr('task_id');
    const isNewPermissionTask = $(element).data('flag') === 'new_permission_task';

    if (isNewPermissionTask) {
      Task._handleDeleteUserInvite(inviteLists, inviteId);
    } else {
      Task._checkToRemoveUser(element, inviteId, projectId, taskId);
    }
  }

  static _checkToRemoveUser(element, inviteId, projectId, taskId) {
    var ajaxUrl;
    var userId = { 'user_id': inviteId };
    if (taskId) {
      ajaxUrl = Routes.owner_project_task_is_delete_permission_path(projectId, taskId);
    } else {
      ajaxUrl = Routes.check_delete_permission_for_new_task_owner_project_path(projectId);
    }

    Shared.callAjax(ajaxUrl, userId).done(function(data) {
      if (data.is_delete) {
        Task.checkMemberBeforeDeletePic(element, inviteId, projectId, taskId)
      } else {
        Popup.alert(I18n.t('task.cannot_remove_permission'));
      }
    })
  }

  selectFile(element, submit) {
    if(submit)  {
      this.submitEditTaskDetail()
      return;
    } else {
      if (!this._validateTaskFiles(element)) return;
      const form = this._resolveTaskForm(element);
      let files = $(element)[0].files;
      this._showFilesSelected(files, form)
    }
  }

  removeFile(element) {
    const attachmentOuter = $(element).closest('.attachment_outer');
    const id = attachmentOuter.find('.attachment').attr('data-id');
    attachmentOuter.remove(500);
    const form = this._resolveTaskForm(element);
    const inputFile = form.find('input[type="file"][name="task[files][]"]');
    if (inputFile.length === 0) return;
    let files = inputFile[0].files;
    files = [...files].filter(file => file !== files[id])
    this._showFilesSelected(files, form)
    if (files.length > 0) {
      let dt = new DataTransfer()
      $.each(files, function(k, file) {
        dt.items.add(file)
      })
      inputFile[0].files = dt.files
    } else {
      inputFile.val('')
    }
  }

  removeCopiedAttachment(element) {
    const attachmentOuter = $(element).closest('.attachment_outer');
    const form = this._resolveTaskForm(element);
    attachmentOuter.remove();
    Task._syncCopiedAttachmentIds(form)
    Task._toggleCopyAttachmentsDisplay(form)
  }

  _showFilesSelected(files, form = null) {
    const scopedForm = form || $('#new_task')
    const isCopyTaskForm = scopedForm.hasClass('copy-task-form')
    const container = isCopyTaskForm ?
      scopedForm.find('.copy-attachments-list') :
      (scopedForm.find('.new-attachments-list').length > 0 ? scopedForm.find('.new-attachments-list') : scopedForm.find('.display-file-area .wrapp').first());
    let html = '';
    for (let i = 0; i < files.length; i++) {
      let fileName = files[i].name.split('.');
      let extension = fileName[fileName.length - 1]
      let baseFileName = fileName.slice(0, -1).join('.') || fileName[0]
      let truncateFileName = `${Shared.truncateString(baseFileName, 10)}.${extension}`
      let isImage = ['jpg', 'gif', 'png', 'jpeg'].includes(extension);

      html += `<div class="attachment_outer ${isCopyTaskForm ? 'new-attachment-item' : ''}">
        <div data-id="${i}" class="attachment">
          <div class="download-link ${isImage ? 'download-image' : 'download-text'} fs-12 text-dark">
            <div class="filename">${truncateFileName}</div>
            ${isImage ? `<img src="${window.URL.createObjectURL(files[i])}" width="100%">` : '<i data-feather="file-text" class="icon_file_text"></i>'}
          </div>
        </div>
        <button type="button" class="btn-delete-attachment" onclick="Task.removeFile(this)">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x text_x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
        </button>
      </div>`
    }
    if (isCopyTaskForm) {
      container.find('.new-attachment-item').remove()
      if (html === '') {
        Task._toggleCopyAttachmentsDisplay(scopedForm)
      } else {
        container.append(html)
        Task._toggleCopyAttachmentsDisplay(scopedForm)
        feather.replace();
      }
    } else {
      if (html == '') {
        container.addClass('d-none')
        container.removeClass('d-flex')
        container.html('')
      } else {
        container.addClass('d-flex')
        container.removeClass('d-none')
        container.html(html)
        feather.replace();
      }
    }
  }

  reset() {
    defaultAction.run()
    $('#new_task').find('#title').val('');
    $('#new_task').find('.js-datepicker').val('');
    $('#new_task').find('#task_description').val('');
    $('#new_task').find('#task_parent_id').val('');
    $("#createTaskProjectModal").modal("hide")
  }

  _resolveTaskForm(element) {
    const form = $(element).closest('form');
    return form.length > 0 ? form : $('#new_task');
  }

  showHideChangeStatus(element) {
    const thisTr = $(element).closest('.ggroupitem')
    if (thisTr.hasClass('child-ticket')) return
    const thisPopup = $(element).closest('.gadditional-pStatus').find('.taskStatusPpopup')
    if(thisPopup.hasClass('show')){
      thisPopup.removeClass('show')
    }else{
      if($('.taskStatusPpopup').hasClass('show')){
        $('.taskStatusPpopup').removeClass('show')
      }
      const lastPopupStatus = $('body').find('.taskStatusPpopup:last');
      if (!lastPopupStatus.hasClass('last-task')) lastPopupStatus.addClass('last-task')
      thisPopup.addClass('show')
    }
  }

  showHideChangeStatusSp(ele) {
    const thisPopup = $(ele).find('.taskStatusPpopupSp')
    if(thisPopup.hasClass('show')){
      thisPopup.removeClass('show')
    }else{
      if($('.taskStatusPpopupSp').hasClass('show')){
        $('.taskStatusPpopupSp').removeClass('show')
      }
      thisPopup.addClass('show')
    }
  }

  settingDeadlineDate(element, taskId, projectId) {
    $(`#modal_expiration_task_${taskId}`).modal('show')
  }

  isTouchThumbnailDevice() {
    return window.matchMedia('(hover: none), (pointer: coarse)').matches || navigator.maxTouchPoints > 0
  }

  closeThumbnailToasts() {
    $('#tbody-list-task .project-thumb-wrapper-toast .zoom-hover').removeClass('zoom-hover')
    $('#tbody-list-task .thumb-sub-icons-group img').removeClass('click-zoom-in')
    $(document).off('.taskThumbnailToast')
  }

  openThumbnailToastForTouch(ele, taskId, type, event) {
    if (!this.isTouchThumbnailDevice()) return false

    const thumbnail = $(ele).closest('.element-thumbnail')
    const toastEle = thumbnail.find(`.project-thumb-${type}-label-toast-${taskId}`)
    const isOpen = toastEle.hasClass('zoom-hover')

    if (isOpen) {
      this.closeThumbnailToasts()
      return true
    }

    event?.preventDefault()
    event?.stopPropagation()

    this.closeThumbnailToasts()
    toastEle.addClass('zoom-hover')

    const iconImg = $(ele).is('img') ? $(ele) : $(ele).find('img').first()
    iconImg.addClass('click-zoom-in')

    $(document).on('click.taskThumbnailToast', (e) => {
      if (!$(e.target).closest(thumbnail).length) {
        this.closeThumbnailToasts()
      }
    })

    return false
  }

  handleThumbnailNotifyTap(ele, taskId, projectId, currentStatus, bypassConfirm, event, canSetting = true) {
    const shouldOpenAction = this.openThumbnailToastForTouch(ele, taskId, 'noti', event)
    if (!this.isTouchThumbnailDevice() || shouldOpenAction) {
      if (canSetting) {
        this.openModalSettingStatusTask(taskId, projectId, currentStatus, bypassConfirm)
      } else {
        this.cannotSettingNotify()
      }
    }
  }

  handleThumbnailDeadlineTap(ele, taskId, projectId, event) {
    const shouldOpenAction = this.openThumbnailToastForTouch(ele, taskId, 'background', event)
    if (!this.isTouchThumbnailDevice() || shouldOpenAction) {
      this.settingDeadlineDate(ele, taskId, projectId)
    }
  }

  handleThumbnailChatTap(ele, taskId, event) {
    const shouldOpenAction = this.openThumbnailToastForTouch(ele, taskId, 'chat', event)
    if (!this.isTouchThumbnailDevice()) return true
    if (!shouldOpenAction) return false

    this.closeThumbnailToasts()
    return true
  }

  showFileSizeTask(ele, taskId) {
    $(`#modal-show-task-file-size-${taskId}`).modal('show')
  }

  showTotalQuantity(ele, taskId) {
    $(`#modal-show-task-total-quantity-${taskId}`).modal('show')
  }

  resetExpirationDate(ele, taskId) {
    const modalComponent = $(ele).parents('.modal-content');
    let color = $(ele).attr('data-current-color') || 'blue';
    modalComponent.find('input#expiration-date-start').val('');
    modalComponent.find('input#expiration-date-end').val('');
    modalComponent.find('#colorPicker').find(`div[data-color="${color}"]`).trigger('click');
  }

  cancelSelectExpirationDate(event) {
    const tdEle = $(event.target).parents('div.modal_expiration_task');
    const startDate = tdEle.find('input#expiration-date-start').data('current-date').replaceAll('-', '/');
    const endDate = tdEle.find('input#expiration-date-end').data('current-date').replaceAll('-', '/');
    $(event.target).parents('.modal-content').find('input#expiration-date-start').val(startDate);
    $(event.target).parents('.modal-content').find('input#expiration-date-end').val(endDate);
  }

  setExpirationDate(ele, projectId, taskId) {
    const modalComponent = $(ele).parents('.modal_expiration_task')
    const startDate = modalComponent.find('#expiration-date-start').val()
    const endDate = modalComponent.find('#expiration-date-end').val()
    const color = modalComponent.find(`input#colorInput_task_${taskId}`).val()
    const url = Routes.change_dateline_of_task_owner_project_tasks_path(projectId)
    const task = this
    Shared.callAjax(url, { task_id: taskId, start_date: startDate, due_date: endDate, colors: color }).done(function(data) {
      $("#task-expiration-date-" + projectId + "-" + taskId).text(endDate)
      modalComponent.find('#expiration-date-start').data('current-date', startDate)
      modalComponent.find('#expiration-date-end').data('current-date', endDate)
      task.refreshCurrentGanttChart()
      task._showPopupReload('期限を更新しました。')
    })
    .fail(function(data) {
      task._showPopupReload('変更に失敗しました。')
    })
  }

  _showPopupReload(message) {
    Popup.confirm(message, {
      cancelBtn: 'false',
      confirmText: 'OK',
      successBtn: 'false',
      width: 'auto',
      timer: 3000,
      kind: 'akaire'
    })
  }

  refreshCurrentGanttChart() {
    if (typeof window.refreshCurrentGanttChart === 'function') {
      window.refreshCurrentGanttChart()
    }
  }

  showModalWorkHistory(workId) {
    $(`#dropdownMenuButtonWorkHistoty-${workId}`).modal('show')
  }

  showWorkSize(ele, workId) {
    $(`#modal-show-work-file-size-${workId}`).modal('show')
  }

  showHideSettingPic(projectID, taskId, newTask = false, fromAfterCreateTask = false) {
    const url = Routes.owner_project_task_get_list_participants_path(projectID, taskId)
    Shared.callAjax(url, { task_id: taskId, new_task: newTask, from_after_create_task: fromAfterCreateTask }, 'script', 'GET')
  }

  showSettingPicTaskInAfterCreateTask(projectId, taskId) {
    $('#afterCreateTaskProjectModalFromTwoOptions').attr('data-transitioning-to-child', 'true')
    Shared.hideModalForElement('#afterCreateTaskProjectModalFromTwoOptions')
    this.showHideSettingPic(projectId, taskId, false, true)
  }

  notInviteMemberInAfterCreateTask() {
    const modal = $('#afterCreateTaskProjectModalFromTwoOptions')
    const projectId = modal.attr('data-project-id')
    this.finalizeAfterCreateTaskMemberSetup(() => {
      window.location.href = Routes.owner_list_grantcharts_path(projectId, { task_created: 1 })
    })
  }

  finalizeAfterCreateTaskMemberSetup(successCallback = null, failureCallback = null) {
    const modal = $('#afterCreateTaskProjectModalFromTwoOptions')
    const projectId = modal.attr('data-project-id')
    const taskId = modal.attr('data-task-id')
    const isPendingMemberSetup = !modal.find('.task-after-create-actions').hasClass('d-none')

    if(!isPendingMemberSetup) {
      if (typeof successCallback === 'function') successCallback()
      return
    }

    if(!projectId || !taskId) {
      if (typeof successCallback === 'function') successCallback()
      return
    }

    Shared.callAjax(
      Routes.owner_send_mail_to_default_permission_of_task_path(projectId, taskId),
      {},
      'json',
      'post'
    ).done(() => {
      modal.attr('data-member-setting-completed', 'true')
      if (typeof successCallback === 'function') successCallback()
    }).fail(() => {
      if (typeof failureCallback === 'function') {
        failureCallback()
        return
      }

      Popup.alert(I18n.t('shared.one_error_please_try_again'))
    })
  }

  updateAfterCreateTaskMemberInfo(numberUser) {
    const modal = $('#afterCreateTaskProjectModalFromTwoOptions')
    modal.attr('data-transitioning-to-child', 'false')
    modal.attr('data-member-setting-completed', 'true')
    modal.find('#number-member-invite-after-create-task .number-add-member-invite').text(`${numberUser}名`)
    modal.find('#number-member-invite-after-create-task').removeClass('d-none')
    modal.find('.task-after-create-actions').addClass('d-none').hide()
    modal.find('.task-after-create-actions button').addClass('d-none')
    this.syncAfterCreateTaskModalBackStack()
  }

  closeAfterCreateTaskModal() {
    const modal = $('#afterCreateTaskProjectModalFromTwoOptions')

    if (modal.attr('data-closing-after-finalize') == 'true') return
    if (modal.attr('data-finalizing-before-close') == 'true') return

    modal.attr('data-transitioning-to-child', 'false')
    modal.removeAttr('data-tm-parent-modal-id')
    modal.attr('data-finalizing-before-close', 'true')

    this.finalizeAfterCreateTaskMemberSetup(() => {
      this.updateAfterCreateTaskMemberInfo(0)
      modal.attr('data-closing-after-finalize', 'true')
      modal.attr('data-finalizing-before-close', 'false')
      this.forceHideAfterCreateTaskModal()
    }, () => {
      modal.attr('data-finalizing-before-close', 'false')
      modal.attr('data-closing-after-finalize', 'false')
    })
  }

  forceHideAfterCreateTaskModal() {
    const modal = $('#afterCreateTaskProjectModalFromTwoOptions')
    if (!modal.length) return

    modal.attr('data-closing-after-finalize', 'true')
    modal.modal('hide')
  }

  openAddMemberModal(projectId, taskId) {
    Shared.callAjax(
      Routes.owner_project_task_get_list_participants_path(projectId, taskId),
      { task_id: taskId },
      'script',
      'GET'
    ).done(() => {
      setTimeout(() => { this.openAddPicModal(true) }, 0)
    }).fail(() => {
      Popup.alert(I18n.t('shared.one_error_please_try_again'))
    })
  }

  settingShowAgain(element) {
    const url = Routes.setting_show_again_owner_users_path()
    const check_status = $(element).is(":checked")
    Shared.callAjax(url, { checked: check_status }, 'script', 'POST')
  }

  settingShowProjectAgain(element) {
    const url = Routes.setting_show_again_project_owner_users_path()
    const check_status = $(element).is(":checked")
    Shared.callAjax(url, { checked: check_status }, 'script', 'POST')
  }

  akaireTaskRemoveMember(event, element, projectId, taskId, userId) {
    event.preventDefault();
    Task._checkToRemoveUser(element, userId, projectId, taskId)
  }

  changeStatusPopup(element, taskId, projectID){
    const newState = $(element)
    const oldState = newState.closest('.taskStatusPpopup').find('.active')
    const status_data = {'status_green': 'preparation', 'status_orange': 'working', 'status_red': 'complete', 'status_gray': 'on_hold'}
    oldState.removeClass('active')
    const oldStateName = oldState.attr('class').split(' ')[0]
    oldState.attr('onclick', `Task.changeStatus(this, '${taskId}', '${projectID}', '${status_data[oldStateName]}')`)
    newState.addClass('active').attr('onclick', '')
  }

  closeChangeStatus() {
    $(document).on('click', function(e) {
      if ($(e.target).hasClass('taskStatus')) return
      $('.taskStatusPpopup').removeClass('show')
    })
  }

  changeStatusWithSelect(ele, taskId, projectId, reload = false) {
    const status = $(ele).attr('value')
    const url = Routes.owner_project_task_change_status_of_task_with_akaire_path(projectId, taskId)
    Shared.callAjax(url, { status: status }, 'html').done(function(data) {
      if (data.includes('errors:')) {
        Popup.alert(data.replaceAll('errors:'))
        return
      }
      if (reload) {
        Shared.reloadCurrentPage();
      } else {
        Popup.alert(I18n.t('task.update.status.success'))
      }
      $('#change-status-of_task-new').html(data)
    })
  }

  showListStatusTask(ele) {
    $(ele).find('.taskStatusPpopupLi').toggleClass('show')
    $(ele).find('.taskStatusPpopupLi').toggleClass('d-none')
  }

  showListStatusTaskWithId(ele, taskId) {
    $(ele).find(`#taskStatusPpopupLi_${taskId}`).toggleClass('show')
    $(ele).find(`#taskStatusPpopupLi_${taskId}`).toggleClass('d-none')
  }

  showPopupUpgradePlanOfExpirationNotice() {
    $('#modalUpgradePlanOfExpirationNotice').modal('show')
  }

  changeStatus(element, taskId, projectID, status_new, status_old = '') {
    if ($(element).hasClass('active')) return

    const url = Routes.owner_project_task_change_status_path(projectID, taskId)
    const statusStyle = this.fetchStatusStyle(status_new);
    const statusStyleForTable = statusStyle.replace('_point', '')
    const statusClasses = ['status_green_point', 'status_orange_point', 'status_red_point', 'status_gray_point'];
    const statusClassesForTable = ['status_green', 'status_orange', 'status_red', 'status_gray'];
    Shared.callAjax(url, { status: status_new }).done(function(data) {
      const $statusContainer = $(`#status-task-${taskId}`).parent()
      const $currentModal = $(element).closest('.modal')
      const $statusPoint = $statusContainer.find('.style-point')
      const $thumbnailStatusPoints = $(`.task-thumb-status-point-${taskId}`)

      $statusPoint.removeClass(`${statusClasses.join(' ')} ${statusClassesForTable.join(' ')}`).addClass(statusStyleForTable)
      $thumbnailStatusPoints.removeClass(statusClasses.join(' ')).addClass(statusStyle)
      $statusContainer.find('.status_text_description').html(data.status)
      $(element).parent().find('li').removeClass('active')
      $(element).addClass('active')
      $(`#modalSelectStatus-${taskId}, #modalSelectAllTaskStatus-${taskId}`).find(`li[data-status='${status_new}']`).addClass('active')
      $('#modalSelectTaskStatusShared').find(`li[data-status-value='${status_new}']`).addClass('active')
      $currentModal.modal('hide')

      if (window.innerWidth < gon.shared.break_point_for_mobile) {
        Popup.confirm('', {
          description: Shared.textTaskAkaire(I18n.t('task.update.status.success'), I18n.t('task.update.status.success_akapon')),
          confirmText: 'OK',
          cancelBtn: 'false',
          success: () => { window.location.reload() },
          cancel: () => { window.location.reload() },
        })
        return
      }
      Popup.alert(Shared.textTaskAkaire(I18n.t('task.update.status.success'), I18n.t('task.update.status.success_akapon')))
    }).fail(function(data) {
      if (data.status && data.status_code === 401) {
        Popup.alert(Shared.textTaskAkaire(I18n.t('task.update.status.not_permission'), I18n.t('task.update.status.success_akapon')))
        return
      }
      Popup.alert(data.error)
    })
  }

  showStatusWork(ele, workId) {
    $(`#modal-show-work-status-sp-${workId}`).modal('show')
  }

  showDeadLineWork(ele, workId) {
    const modalDate = $(`#modal_expiration_${workId}`)
    modalDate.find('div.modal-body :input').prop('disabled', true)
    modalDate.find('div.modal-footer :button').prop('disabled', true)
    modalDate.find('div.modal-footer :button').attr('onclick', '')
    modalDate.modal('show')
  }

  showTotalQuantityWork(ele, workId) {
    $(`#modal-show-work-total-quantity-${workId}`).modal('show')
  }

  fetchStatusStyle(status_task) {
    let status_style = ''
    switch(status_task) {
      case 'preparation':
          status_style = 'status_green_point'
          break;
      case 'working':
          status_style = 'status_orange_point'
          break;
      case 'complete':
          status_style = 'status_red_point'
          break;
      case 'on_hold':
          status_style = 'status_gray_point'
      break;
    }
    return status_style
  }

  updateSelectDisplayList(projectId, selectValue) {
    const url = `/projects/${projectId}/tasks/update_display_type`
    Shared.callAjax(url, { select_value: selectValue }, '', 'post').done(() => {
      location.reload()
    }).fail(() => {
      Popup.alert(I18n.t('shared.one_error_please_try_again'))
    })
  }

  openModalSettingStatusTask(task_id, project_id, current_status, bypass_confirm) {
    $('#offTaskNoticeStatus').find('.submit-update-status').attr('data-task-id', task_id)
    $('#offTaskNoticeStatus').find('.submit-update-status').attr('data-project-id', project_id)
    $('#onTaskNoticeStatus').find('.submit-update-status').attr('data-task-id', task_id)
    $('#onTaskNoticeStatus').find('.submit-update-status').attr('data-project-id', project_id)
    const bypass_after_setting = $('#tbody-list-task').attr('data-show-confirm-again')
    if((bypass_confirm == 'false' || bypass_confirm == '') && bypass_after_setting == 'false') {
      if(current_status) {
        Shared.showModalForElement('#offTaskNoticeStatus')
      } else {
        Shared.showModalForElement('#onTaskNoticeStatus')
      }
    } else {
      this.updateNotifyStatus($('#onTaskNoticeStatus').find('.submit-update-status'), !current_status)
    }
  }

  cannotSettingNotify() {
    $('#cannotSettingNotify').modal('show')
  }

  updateNotifyStatus(element, status) {
    let task_id = $(element).attr('data-task-id')
    let project_id = $(element).attr('data-project-id')
    let url = Routes.update_notify_status_owner_project_task_path(project_id, task_id)
    Shared.callAjax(url, {status: status}, 'json', 'patch')
    .done(function(data) {
          // [2026-05-21 Probalance] cherry-pick時コンフリクトのため修正
          // 元のSabitech側: #status-sp対応あり・トースト通知なし
          // 弊社側: #status-sp対応なし・tmShowNotifyToast追加。両方を統合。
          if(data.status) {
            $('#onTaskNoticeStatus').modal('hide')
            $(`#status-${task_id}, #status-sp-${task_id}`).find('.accept-notify').removeClass("d-none")
            $(`#status-${task_id}, #status-sp-${task_id}`).find('.reject-notify').addClass("d-none")
            if (window.tmShowNotifyToast) window.tmShowNotifyToast('このタスクの通知設定がONに変わりました。')
          } else {
            $('#offTaskNoticeStatus').modal('hide')
            $(`#status-${task_id}, #status-sp-${task_id}`).find('.accept-notify').addClass("d-none")
            $(`#status-${task_id}, #status-sp-${task_id}`).find('.reject-notify').removeClass("d-none")
            if (window.tmShowNotifyToast) window.tmShowNotifyToast('このタスクの通知設定がOFFに変わりました。')
          }
    }).fail(function(result) {
      $('#onTaskNoticeStatus').modal('hide')
      $('#offTaskNoticeStatus').modal('hide')
      $('#cannotSettingNotify').modal('show')
    })
  }

  toggleTaskAncestryRow(ele, taskId){
    let element = $(ele)
    let tbody = element.closest('tbody')
    let ancestryRow = tbody.find(`.ancestory_row[data-parent="${taskId}"]`)
    let idChilder = ancestryRow.find('td.td_id').text();
    let ancestryRowChilder = tbody.find(`.ancestory_row[data-parent="${idChilder}"]`)
    if(element.hasClass('open')){
      ancestryRow.addClass('d-none')
      if(ancestryRowChilder) {
        ancestryRowChilder.addClass('d-none')
        ancestryRow.find('a.icon_toggle').removeClass('open').html('&nbsp;')
      }
      $(ele).removeClass('open').html('&nbsp;')
    }else{
      ancestryRow.removeClass('d-none')
      $(ele).addClass('open').html('&nbsp;')

    }
  }

  static checkMemberBeforeDeletePic(element, userID, projectId, taskId) {
    if ($('.hide-button').hasClass('d-none')) {
      return;
    }
    const inviteId = $(element).data('inviteid');
    const inviteLists = $('#inviteLists')
    const isNewPermissionTask = $(element).data('flag') === 'new_permission_task';
    if (isNewPermissionTask) {
      Task._removeInviteUser(inviteLists, inviteId);
      return;
    }
    const url = Routes.owner_project_task_check_member_before_delete_pic_path(projectId, taskId)
    const type = $('.akaire_members_pic_box').data('akaire-type')
    Shared.callAjax(url, { user_id: userID })
    .done(function(result){
      if (result.show_popup_warning) {
        Popup.confirm(
          `<div class='text-center font-weight-normal popup-check-member-before-delete'>${result.company_name}の未納品作業が存在します。
            紐づけを解除すると提出済（未納品）作業は削除されます。
            解除すると、未納品作業は<a class="text-underline font-weight-bold" href="${Routes.deleted_works_efforts_path()}">削除済一覧ページ</a>に移動します。
          </div>`,
          {
            success: () => {
              if (type === 'task') {
                Task._requestDeleteUserPermision(projectId, taskId, userID);
              } else {
                Task._removeInviteUser(inviteLists, inviteId);
              }
            },
            cancel: () => {},
            confirmText: '解除する',
            cancelText: 'キャンセル',
            width: 'auto',
          }
        )
      } else if (result.only_send_mail) {
        if (type === 'task') {
          Task._handleDeleteUserInvite(inviteLists, userID, 'action_from_akaire', projectId, taskId);
        } else {
          Task._handleDeleteUserInvite(inviteLists, inviteId);
        }
      }
    }).fail(function(result) {
      Popup.confirm('',{
        description: I18n.t('task.cannot_remove_project_owner'),
        confirmText: 'OK',
        cancelBtn: 'false',
      })
    })
  }

  _setTaskFileName(arr, element) {
    let value = '';
    if (arr.length > 1 && arr.length <= 10) {
      value = arr.length + ' files';
      $('#task_file_label').text(value);
    } else if(arr.length > 10) {
      Popup.alert(I18n.t('task.cannot_select_ten_file'), 'warning');
      $(element).val('');
      return
    } else if (arr.length == 1) {
      value = arr[arr.length - 1];
      $('#task_file_label').text(value);
    }

  }

  _handleFetchData(url, dataAjax, dataType = 'company', disableValues = [], unSubmitValues = []) {
    const task = this
    const idRenderData = dataType === 'company' ? 'js_select_company_invites_task' : 'js-select_users_invites'
    return Shared.callAjax(url, dataAjax).done(function(data) {
      if (data.length === 0) return
      let dataRender = [
        `<option value="" selected disabled></option>`,
        ...data.map(user => {
          const disabled = disableValues.includes(user.id) || unSubmitValues.includes(user.id) ? 'disabled' : ''
          const surfix = disableValues.includes(user.id) ? '（招待済み）' : ''
          const unSubmitSurfix = unSubmitValues.includes(user.id) ? '（選択済み）' : ''
          return `<option value="${user.id}" ${disabled}>${user.name}${surfix}${unSubmitSurfix}</option>`
        })
      ]
      $(`#${idRenderData}`).html(dataRender.join(""));
      task.removeDisabledBtnInvite($(`#${idRenderData}`))
    }).fail(function(data) {
      Popup.alert(I18n.t('task.fetch_company_error'), 'warning');
    })
  }

  _validateTask(form) {
    let isError = false;
    if (form.find('input[name="task[name]"]').val() === '') {
      isError = true;
      Shared.errorFieldMessage(form.find('input[name="task[name]"]'), '');
    }
    form.find('select[required="required"]').toArray().forEach(input => {
      if ($(input).val() === '') {
        isError = true;
        Shared.errorFieldMessage($(input), '');
      }
    })
    return isError;
  }

  _validateTaskFiles(element) {
    var allowedExtensions = ['doc', 'docx', 'odt', 'pdf', 'tex', 'txt', 'rtf', 'xls', 'xlsx', 'mp4', 'wmv', 'avi', 'mov', 'csv', 'psd', 'ai', 'mp3', 'ppt', 'pptx', 'zip', 'draw', 'ait', 'jpg', 'jpeg', 'png', 'wav'];
    var files = $(element)[0].files
    for (let i=0; i<files.length; i++) {
        let file_extension = files[i].name.substr(files[i].name.lastIndexOf('.') + 1).toLowerCase();
        if ($.inArray( file_extension, allowedExtensions ) < 0) {
          Popup.alert(I18n.t('task.not_upload_with_format'));
          $(element).val('');
          return false
        } else {
          $(element).removeClass('is-invalid');
          return true
        }
    }
  }

  showMessageWithChangeTaskType(ele) {
    const currentValue = $(ele).attr('task_category')
    let description = I18n.t('task.change_task_type_web_to_video')
    if (currentValue !== $(ele).val()) {
      if($(ele).val() == 'web') {
        description = I18n.t('task.change_task_type_video_to_web')
      }

      Popup.confirm('',{
        description: description,
        confirmText: 'OK',
        cancelText: 'キャンセル',
        success: () => {
          $(ele).attr('task_category', $(ele).val())
          this.submitEditTaskDetail()
        },
        cancel: () => {
          $(".edit_task").find("#task_category").val(currentValue)
        }
      })
    }
  }

  changePersonInChargeList(element, objectId, projectId, userId, type, is_akaire_file = false) {
    const $ele = $(element);
    const addAction = $ele.is(":checked");
    const listUserUncheck = $('#list-user-uncheck')
    if (!addAction) {
      $("#list-user-uncheck").val(`${listUserUncheck.val()}${userId},`)
      this._checkMemberBeforeDeletePic(element, objectId, projectId, userId, type, is_akaire_file)
    } else {
      $("#list-user-uncheck").val(listUserUncheck.val().replaceAll(`${userId},`, ''));
      this._handleChangePersonInChargeList(element, objectId, projectId, userId, type, is_akaire_file)
    }
  }

  showEleFilterNewAdd(ele, isPositive = true) {
    const tr = $(ele).parents('.show-list-member-for-page')
    if (tr.length > 0 && tr.attr('old-check') && tr.attr('old-check') === 'true') return

    const modal = $(ele).parents('.modal')
    const spanShow = modal.find('.show-number-member-add')
    const text = window.innerWidth <= 576 ? '名' : spanShow.data('text')
    const number = $('.modal_member_add_body .show-list-member-for-page')
    .filter((i, e) => {
        const $el = $(e);
        return !$el.attr('old-check') && $el.find('input').is(":checked");
    }).length
    if (number <= 0) {
      spanShow.addClass('d-none')
      tr.removeAttr('is-new-add')
      return;
    }
    spanShow.attr('data-number', number)
    if (spanShow.attr('is-show') === 'false') {
      spanShow.text(`${number}${text}`)
    } else {
      const textHide = window.innerWidth <= 576 ? '戻る' : spanShow.attr('data-text-hide')
      spanShow.text(textHide)
    }
    if (number === 0) {
      spanShow.addClass('d-none')
      tr.removeAttr('is-new-add')
    } else {
      spanShow.removeClass('d-none')
      tr.attr('is-new-add', 'true')
    }
  }

  showListNewAdd(ele) {
    const modal = $(ele).parents('.modal')
    const listTr = modal.find('div.show-list-member-for-page').toArray()
    const numerCurrentPageMember = modal.find('.render_pagy_of_list_member').find('.page-item.active').data('index').toString()
    if ($(ele).attr('is-show') && $(ele).attr('is-show') === 'true') {
      listTr.forEach(tr => {
        if($(tr).attr('data-page') === numerCurrentPageMember || $(tr).hasClass('tr-new-email')) {
          $(tr).css('display', '')
        } else {
          $(tr).css('display', 'none')
        }
      })
      $(ele).attr('is-show', 'false')
      const text = $(ele).data('text')
      const number = $(ele).attr('data-number')
      $(ele).text(`${number} ${text}`)
      modal.find('.new-style-with-js').removeClass('d-none')
    } else {
      listTr.forEach(tr => {
        if ($(tr).attr('is-new-add') && $(tr).attr('is-new-add') === 'true') {
          $(tr).css('display', '')
        } else {
          $(tr).css('display', 'none')
        }
      })
      $(ele).attr('is-show', 'true')
      $(ele).text($(ele).attr('data-text-hide'))
      modal.find('.new-style-with-js').addClass('d-none')
    }
    document.getElementById("show-table-list-member").scrollIntoView();
  }


  removeParam(key, sourceURL) {
    if (!sourceURL) {
      return;
    }

    let rtn = sourceURL.split("?")[0];
    let param;
    let params_arr = [];
    let queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
    if (queryString !== "") {
      params_arr = queryString.split("&");
      for (let i = params_arr.length - 1; i >= 0; i -= 1) {
        param = params_arr[i].split("=")[0];
        if (param === key) {
          params_arr.splice(i, 1);
        }
      }
      if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
    }
    return rtn;
  }

  changePagynationLinks() {
    const array = $(document).find('.task-list-pagination').find('a.page-link').toArray();
    array.forEach(tagA => {
      let tagAUrl = $(tagA).attr('href')
      tagAUrl = this.removeParam("new_task", tagAUrl);
      tagAUrl = this.removeParam("task_id", tagAUrl);
      $(tagA).attr('href', tagAUrl)
    })
  }

  handleUpdatePicOfTask(element, projectId, taskId){
    const task = this
    let user_invite_ids = [];
    const user_delete_ids = $('#list-user-uncheck').val().split(',').filter(Boolean);
    let user_invite_emails = [];
    let list_invite_member_of_partner = [];
    const modalScope = element ? $(element).closest('#personInChargeOfObject') : $('#personInChargeOfObject')
    const currentUrl = window.location.href
    if(currentUrl.includes('new_task=true')) {
      let newUrl = this.removeParam("new_task", currentUrl);
      newUrl = this.removeParam("task_id", newUrl);
      window.history.pushState( '', '', newUrl);
      this.changePagynationLinks();
    }
    modalScope.find(".pick-pics").each(function( _index, ele ) {
      if($(ele).is(":checked")) {
        if($(ele).attr("name").includes("email")) {
          user_invite_emails.push({email: $(ele).val(), type: $(ele).attr("data-type")})
        } else if($(ele).attr("name").includes("partners")) {
          list_invite_member_of_partner.push({email: $(ele).val(), type: $(ele).attr("data-type"), company_id: $(ele).attr("data-company-id"), name: $(ele).attr("data-name")})
        } else {
          user_invite_ids.push($(ele).val())
        }
      }
    });
    let check_new_task = $("#personInChargeOfObject").attr("data-new-task")
    const fromAfterCreateTask = $("#personInChargeOfObject").attr("data-from-after-create-task") == 'true'
    const url = Routes.owner_update_pics_of_task_path(projectId, taskId)
    Shared.callAjax(url, { list_user_invite: user_invite_ids, list_user_delete: user_delete_ids, list_user_invite_by_email: user_invite_emails, list_invite_member_of_partner: list_invite_member_of_partner, check_new_task: check_new_task })
    .done(function(result){
      if(result.self_remove) {
        $('.modal-backdrop').remove();
        $('#personInChargeOfObject').modal('hide');
        Popup.alert(`タスク「${result.removed_object_name}」のメンバーから解除されました`, '', '', {timer:2500, allowOutsideClick:false, allowEscapeKey:false});
        setTimeout(() => { location.href = location.pathname.replace(/\/tasks\/.*/, '/tasks'); location.reload(); }, 2500);
        return;
      }
      const personInChargeModal = $("#personInChargeOfObject")
      $(`#pic_list_${result.task_id}`).html(`自分と他${result.number_user}名`)
      var akaire_member_text = 'メンバー：自分'
      if(result.number_user != 0) {
        akaire_member_text = `メンバー：自分と他${result.number_user}名`
      }
      $(`#pic_list_${result.task_id}`).html(`自分と他${result.number_user}名`)
      if(result.number_user == '0') $(`#pic_list_${result.task_id}`).html('自分')
      $('.text-akaire-member-list').html(akaire_member_text)
      if(fromAfterCreateTask && $("#afterCreateTaskProjectModalFromTwoOptions").length) {
        var __pid = $('#afterCreateTaskProjectModalFromTwoOptions').attr('data-project-id')
        window.location.href = Routes.owner_list_grantcharts_path(__pid, { task_created: 1 })
        return
      } else if(result.new_task && $("#personInChargeOfObject").attr("data-new-task") == 'true') {
        if($("#akaponAddTaskSuccess").length || $("#ccAddTaskSuccess").length) {
          personInChargeModal.modal("hide")
          if(result.plan_akapon) {
            window.location.href = Routes.akaire_feature_project_task_path(projectId, taskId)
          } else {
            window.location.href = Routes.owner_log_work_task_path(projectId, taskId)
          }
        } else {
          personInChargeModal.one('hidden.bs.modal', function() {
            task.showUpdatePersonInChargeSuccessPopup()
          })
          personInChargeModal.modal("hide")
        }
      } else {
        if($("#personInChargeOfObject").attr("data-check-new") == 'true') {
          personInChargeModal.one('hidden.bs.modal', function() {
            task.showUpdatePersonInChargeSuccessPopup()
          })
          personInChargeModal.modal("hide")
        } else {
          personInChargeModal.one('hidden.bs.modal', function() {
            task.showUpdatePersonInChargeSuccessPopup()
          })
          personInChargeModal.modal("hide")
        }
      }
      $('.list-permission').find('.list-permission-name').html(result.approve_participants_name)
      $('.list-waiting-permission').find('.list-permission-name').html(result.unapprove_participants_name)
    }).fail(function() {
      Popup.confirm(I18n.t('work.changed_refresh'), {
        success: () => {
          window.location.href = Routes.owner_list_grantcharts_path(projectId)
        },
        cancel: () => {
          window.location.href = Routes.owner_list_grantcharts_path(projectId)
        },
        confirmText: 'OK',
        cancelBtn: 'false',
        width: '35rem'
      })
    })
  }

  submitEditTaskDetail() {
    $('.bootstrap-datetimepicker-widget').hide().remove()
    $('.datetimepicker').each(function() {
      const picker = $(this).data('DateTimePicker')
      if (picker) {
        picker.hide()
      }
    })
    $("#submit-edit-task").click()
  }

  _checkMemberBeforeDeletePic(element, objectId, projectId, userId, type, is_akaire_file) {
    if($(element).parents('.show-list-member-for-page').attr('is-new-add') == 'true') {
      const userName = $(element).parent().parent().find(".t_name").find('p').attr("data-original-title")
      this._removeMemberNotSubmit(userId, userName)
      this.showEleFilterNewAdd(element, false)
      return
    }

    const url = Routes.owner_project_task_check_member_before_delete_pic_path(projectId, objectId)
    const task = this
    const listUserUncheck = $('#list-user-uncheck').val().split(',').filter(Boolean)

    Shared.callAjax(url, { user_id: userId, list_user_uncheck: listUserUncheck, is_akaire_file: is_akaire_file })
    .done(function(result){
      task.showEleFilterNewAdd(element, false)
      $("#personInChargeOfObject").attr('data-is-change', 'true')
      let message = `<div class='text-center font-weight-normal popup-check-member-before-delete'><p>${result.user_name}さんを招待解除すると、このタスクの紐づけが解除され <br>未納品作業が削除されます。</p>
        <a class="text-underline font-weight-bold" target="_blank" href="${Routes.undelivered_works_efforts_path({search_kind: 'task_id_cont', q: { kind_id: objectId, created_by_eq: result.is_client ? null : userId }})}">未納品作業一覧ページ</a>より未納品作業をご確認の上、メンバー解除を行ってください。
        メンバー解除後、10日間は<a class="text-underline font-weight-bold" target="_blank" href="${Routes.deleted_works_efforts_path()}">削除一覧ページ</a>より未納品作業のStatus変更が可能です。
        10日を超過すると未納品作業のStatus変更は出来ません。
      </div>`
      if (result.is_client) {
        message = `<div class='text-center font-weight-normal popup-check-member-before-delete'>${result.company_name}の未納品が存在します。<br>紐づけを解除すると提出済（未納品）作業は削除されます。<br>解除すると、未納品作業は<a class="text-underline font-weight-bold" href="${Routes.deleted_works_efforts_path()}" target="_blank">削除済一覧ページ</a>に移動します。
        </div>`
      }

      if (result.show_popup_warning) {
        Popup.confirm(
          message,
          {
            success: () => {},
            cancel: () => {
              $(element).prop("checked", true)
              $(element).parent().append("<div class='check-view check2'></div>")
            },
            confirmText: '解除する',
            cancelText: 'キャンセル',
            width: 'auto',
          }
        )
      } else if (result.only_send_mail) {}
    }).fail(function(result) {
      var description = I18n.t('task.cannot_remove_project_owner')
      if(result.responseJSON.delete_pic_role == 'main_admin'){
        description = I18n.t('task.cannot_remove_project_main_admin')
      }


      $(element).prop("checked", true)
      $(element).parent().append("<div class='check-view check2'></div>")
      Popup.confirm('',{
        description: description,
        confirmText: 'OK',
        cancelBtn: 'false',
      })
    })
  }

  _handleDeleteUserInviteOfListTask(element, objectId, projectId, userId, type) {
    const url = Routes.delete_person_incharge_owner_project_tasks_path(projectId)
    Shared.callAjax(url, { task_id: objectId, type: type, user_id: userId }).done(function(data) {
      if(data.self_remove) {
        Popup.alert(`タスク「${data.removed_object_name}」のメンバーから解除されました`, '', '', {timer:2500, allowOutsideClick:false, allowEscapeKey:false});
        setTimeout(() => location.reload(), 2500);
        return;
      }
      $(element).parents('td').find('span.text-number-user').text(`自分と他${data.number_user}名`)
    })
    .fail(function(result) {
      Popup.alert(I18n.t('task.cannot_remove_project_owner'))
    })
  }

  _removeMemberNotSubmit(userId, userName) {
    const idAddUserInvite = $('#idAddUserInvite').val()
    const list_permission_name = $('.list-permission').find('.list-permission-name').html()
    const userDelete = $('.list-user-invite-delete');

    if(idAddUserInvite.includes(`, ${userId}`)){
      $('#idAddUserInvite').val(idAddUserInvite.replace(`, ${userId}`, ''))
    }else{
      $('#idAddUserInvite').val(idAddUserInvite.replace(userId, ''))
    }

    if($('.list-permission').find('.list-permission-name').length) {
      if(list_permission_name.includes(`, ${userName}`)) {
        $('.list-permission').find('.list-permission-name').html(list_permission_name.replace(`, ${userName}`, ''))
      } else {
        $('.list-permission').find('.list-permission-name').html(list_permission_name.replace(userName, ''))
      }
    }

    userDelete.val(`${userDelete.val()}, ${userId}`)
    $('.list-user-invite-task').val(`[${$('#idAddUserInvite').val()}]`)
  }

  _handleChangePersonInChargeList(element, objectId, projectId, userId, type, is_akaire_file) {
    const task = this
    const url = Routes.check_add_permission_to_task_owner_project_tasks_path(projectId)
    const userDelete = $('.list-user-invite-delete').val();
    Shared.callAjax(url, { task_id: objectId, user_id: userId, is_akaire_file: is_akaire_file }).done(function(data) {
      $("#personInChargeOfObject").attr('data-is-change', 'true')
      if (data.is_invite) {
        // task._handleAddPermisionToTask(element, objectId, projectId, userId, type)
        if($(".list-permission").find(".list-permission-name").length) {
          const idAddUserInvite = $('#idAddUserInvite').val()
          if(idAddUserInvite.length > 0){
            $('#idAddUserInvite').val(`${idAddUserInvite},${userId}`)
          }else{
            $('#idAddUserInvite').val(userId)
          }
          $('.list-user-invite-task').val(`[${$('#idAddUserInvite').val()}]`)
        }
        if(userDelete !== null && userDelete !== undefined) {
          if(userDelete.includes(`, ${userId}`)) {
            $('.list-user-invite-delete').val(userDelete.replaceAll(`, ${userId}`, ''))
          } else {
            $('.list-user-invite-delete').val(userDelete.replaceAll(userId, ''))
          }
        }
        task.showEleFilterNewAdd(element)
      } else {
        $(element).prop("checked", false)
        $(element).parent().find(".check-view").remove()
        Popup.alert(I18n.t('task.not_invite'))
      }
    })
    .fail(function(data) {
      $(element).prop("checked", false)
      $(element).parent().find(".check-view").remove()
      if (data.responseJSON.is_plan_akapon) {
        var entityFile = $('#entity_type_akaire_file').val();
        var message = '';
        if(entityFile == 'Work') {
          message = 'アカポン会員はチケットファイル<br>に招待できません。'
        } else if(entityFile == 'Task') {
          message = 'アカポン会員はタスクファイル<br>に招待できません。'
        } else {
          message = 'アカポン会員はタスク<br>に招待できません。'
        }
        Popup.alert(message)
        return
      }
      Popup.alert(I18n.t('task.not_invite'))
    })
  }

  _handleAddPermisionToTask(element, objectId, projectId, userId, type) {
    const url = Routes.add_person_incharge_owner_project_tasks_path(projectId)
    Shared.callAjax(url, { task_id: objectId, type: type, user_id: userId }).done(function(data) {
      $(element).parents('td').find('span.text-number-user').text(`自分と他${data.number_user}名`)
    })
    .fail(function(data) {
      Popup.alert(I18n.t('task.not_invite'))
    })
  }

  settingPicsOffTask(task_id){
    $(`#personInCharge${task_id}`).modal("show")
  }

  static _removeInviteUser(inviteLists, inviteId) {
    const inviteListsItem = inviteLists.find(`span[data-inviteid='${inviteId}']`);
    const inviteListsItemName = inviteListsItem.text();
    const isNewPermissionTask = inviteListsItem.data('flag') === 'new_permission_task';
    const companySelectedId = $('#js_select_company_invites_task :selected').val();
    const memberModal = $('#personInChargeOfObject');

    if (companySelectedId == inviteListsItem.data('companyid')) {
      const elementAdd = `<option value="${inviteId}">${inviteListsItemName}</option>`;
      $('#js-select_users_invites').append(elementAdd);
    }
    $('.view_box_lists').find(`.dropdown-item[data-inviteid='${inviteId}']`).remove();
    inviteListsItem.remove();
    const listUserInvite = JSON.parse(inviteLists.find('.list-user-invite-task').val())
    const newListUser = Shared.removeElementOfArray(listUserInvite, inviteId)
    inviteLists.find('.list-user-invite-task').val(`[${newListUser}]`);

    if (!isNewPermissionTask) {
      const userDelete = inviteLists.find('.list-user-invite-delete');
      userDelete.val(`${userDelete.val()}, ${inviteId}`)
    } else {
      const spanShow = memberModal.find('.show-number-member-add');
      const currentCount = Number(spanShow.attr('data-number') || 0);
      const nextCount = Math.max(0, currentCount - 1);
      const row = memberModal.find(`input[value="${inviteId}"]`).closest('.show-list-member-for-page');

      row.remove();
      spanShow.attr('data-number', nextCount);

      if (nextCount === 0) {
        spanShow.addClass('d-none');
      } else if (spanShow.attr('is-show') === 'false') {
        const text = window.innerWidth <= 576 ? '名' : spanShow.data('text');
        spanShow.removeClass('d-none').text(`${nextCount}${text}`);
      } else {
        const textHide = window.innerWidth <= 576 ? '戻る' : spanShow.attr('data-text-hide');
        spanShow.removeClass('d-none').text(textHide);
      }
    }
  }

  static _closeTaskCallback(taskChildIds) {
    taskChildIds.forEach( (id) => {
      Visiable.hide(`.task_parent_${id}`)
      Collapsible.close($(`#fas_${id}`))
    })
  }

  static _renderTaskCopy(task, taskComponent, users, attachments = [], sourceTaskName = '') {
    const taskId = taskComponent.attr('id')?.replace('copyTaskModal-', '')
    const memberModal = taskId ? $(`#copyTaskMembersModal-${taskId}`) : $()
    taskComponent.find('input[name="task[parent_id]"]').val(task.parent_id);
    taskComponent.find('input[name="task[name]"]').val(task.name)
    taskComponent.find('select[name="task[category]"]').val(task.category);
    taskComponent.find('select[name="task[priority_colors]"]').val(task.priority_colors);
    taskComponent.find('input[name="task[start_date]"]').val(task.start_date);
    taskComponent.find('input[name="task[due_date]"]').val(task.due_date);
    taskComponent.find('textarea[name="task[description]"]').val(task.description);
    taskComponent.find('.copy-task-source-name').text(sourceTaskName || task.name);
    taskComponent.find('.color_picker').find(`div[data-color="${task.colors}"]`).trigger('click');
    taskComponent.find('.invite_lists_inner').empty();
    memberModal.find('.copy-task-members-modal-list').empty();
    taskComponent.find('.list-user-invite-task').val('[]')
    taskComponent.find('input[type="file"][name="task[files][]"]').val('')
    taskComponent.find('.custom-file-label').text('ファイル選択')
    taskComponent.find('.copy-attachments-list').html('').removeClass('d-none').removeClass('d-flex')
    users.forEach(user => {
      let listUserInvite = JSON.parse(taskComponent.find('.list-user-invite-task').val())
      let spanTag = `<span class="invite_name" data-inviteid="${user[0]}" title="${user[1]}">${user[1]}</span>`
      let liTag = `<li class="list-group-item" data-inviteid="${user[0]}" title="${user[1]}">${user[1]}</li>`
      taskComponent.find('.invite_lists_inner').append(spanTag);
      memberModal.find('.copy-task-members-modal-list').append(liTag);
      listUserInvite.push(user[0]);
      taskComponent.find('.list-user-invite-task').val(`[${listUserInvite}]`);
    })

    Task._renderCopiedAttachments(taskComponent, attachments)
  }

  static _renderCopiedAttachments(taskComponent, attachments = []) {
    const container = taskComponent.find('.copy-attachments-list')
    let html = ''

    attachments.forEach((attachment) => {
      const arr = attachment.name.split('.')
      const ext = arr[arr.length - 1].toLowerCase()
      const isImage = ['jpg', 'gif', 'png', 'jpeg'].includes(ext)
      const displayName = Shared.truncateString(attachment.name, 18)
      html += `<div class="attachment_outer copied-attachment-item" data-attachment-id="${attachment.id}">
        <div data-id="${attachment.id}" class="attachment">
          <a href="${attachment.url}" class="download-link ${isImage ? 'download-image' : 'download-text'} fs-12 text-dark" target="_blank" rel="noopener noreferrer" title="${attachment.name}">
            <div class="filename">${displayName}</div>
            ${isImage ? `<img src="${attachment.url}" width="100%">` : '<i data-feather="file-text" class="icon_file_text"></i>'}
          </a>
        </div>
        <button type="button" class="btn-delete-attachment" onclick="Task.removeCopiedAttachment(this)">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x text_x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
        </button>
      </div>`
    })

    container.html(html)
    Task._toggleCopyAttachmentsDisplay(taskComponent)
    Task._syncCopiedAttachmentIds(taskComponent)
    feather.replace()
  }

  static _syncCopiedAttachmentIds(taskComponent) {
    const attachmentIds = taskComponent.find('.copied-attachment-item').map((_, element) => $(element).data('attachment-id')).get()
    taskComponent.find('.copied-attachment-ids').val(attachmentIds.join(','))
  }

  static _toggleCopyAttachmentsDisplay(taskComponent) {
    const displayArea = taskComponent.find('.copy-attachments-display-area')
    const container = taskComponent.find('.copy-attachments-list')
    if (container.children().length === 0) {
      displayArea.addClass('d-none')
      container.removeClass('d-flex').addClass('d-none')
    } else {
      displayArea.removeClass('d-none')
      container.addClass('d-flex').removeClass('d-none')
    }
  }

  static _requestDeleteUserPermision(projectId, taskId, userId) {
    const userIdVar = userId;

    Shared.callAjax(
      Routes.supplier_project_task_remove_user_task_permission_path(projectId, taskId, {user_id_to_remove: userId})
    ).done(function(data) {
      $(`.akaire_members_pic_box .user-item[data-userid='${userIdVar}'`).remove();
      const memberCount = parseInt($('.btn-akaire-member-list')[0].dataset.membersCount)
      if (memberCount - 1 == 1) {
        $('.btn-akaire-member-list').find('a')[0].text = 'メンバー：自分';
      }
      else {
        $('.btn-akaire-member-list').find('a')[0].text = `メンバー：自分と他${memberCount - 2}名`
      }
      $('.btn-akaire-member-list')[0].dataset.membersCount = memberCount - 1
    }).fail(function(data) {
      Popup.alert('エラーが発生しました。再度確認してください。');
    })
  }

  static _handleDeleteUserInvite(inviteLists, inviteId, action_from = null, projectId = null, taskId = null) {
    if(!inviteLists.hasClass('disabled')){
      Popup.confirm('', {
          description: I18n.t('task.do_you_want_remove_user_invite'),
          confirmText: 'OK',
          success: () => {
            if (action_from) {
              Task._requestDeleteUserPermision(projectId, taskId, inviteId);
            } else {
              Task._removeInviteUser(inviteLists, inviteId);
            }
          },
        }
      )
    }
  }

  showChangeTaskType(taskId) {
    $(`#modal-show-change-task-type-${taskId}`).modal('show');
  }

  changeTaskType(ele, taskId, projectId, type) {
    $(`#modal-show-change-task-type-${taskId}`).modal('hide')
    const typeText = type === 'video' ? '動画' : 'WEB'
    const message = `赤入れ種別を${typeText}に変更します。<br>種別を変更すると、前の種別データは削除されます。<br>変更してよろしいですか？`
    Popup.confirm(message, {
      confirmText: 'OK',
      success: () => {
        this._handeChangeTaskType(taskId, projectId, type)
      },
      cancelText: 'キャンセル',
      confirmButtonColor: this.colorPlanAkapon()
    })

  }

  _handeChangeTaskType(taskId, projectId, type) {
    const typeText = type === 'video' ? '動画' : 'WEB'
    const message = `赤入れ種別を${typeText}に変更しました。`
    const url = Routes.owner_project_task_change_task_type_path(projectId, taskId)
    Shared.callAjax(url, { type: type }).done((res) => {
      Popup.confirm(message, {
        confirmText: 'OK',
        cancelBtn: 'false',
        success: () => { Shared.reloadPage() },
        cancel: () => { Shared.reloadPage() },
        confirmButtonColor: this.colorPlanAkapon()
      })
    }).fail((res) => {
      let message = 'エラーが発生しました。再度確認してください。'
      if (res.responseJSON && res.responseJSON.message) message = res.responseJSON.message
      Popup.confirm(message, {
        confirmText: 'OK',
        cancelBtn: 'false',
        success: () => { Shared.reloadPage() },
        cancel: () => { Shared.reloadPage() },
        confirmButtonColor: this.colorPlanAkapon()
      });
    })
  }

  openEditTask(ele) {
    const tdEle = $(ele).parents('td.td_name')
    tdEle.find('a.link-show-name-task').addClass('d-none')
    tdEle.find('input.input-task-text-name').removeClass('d-none')
  }

  hideEditTaskName(ele, taskId) {
    const parent = $(ele).parent()
    parent.find(`.task-name-link-${taskId}`).removeClass('d-none')
    parent.find('.edit-task-name-img').removeClass('d-none')
    parent.find('.input-task-text-name').addClass('d-none').off('keydown.taskThumb')
    parent.find('.edit-task-name-backdrop').addClass('d-none').off('click.taskThumb')
  }

  handleChangeTaskName(input, taskId, projectId) {
    const newName = input.val().trim()
    const oldName = input.data('origin-name')

    if (!newName.length) {
      Popup.alert('タスク名を入力してください。')
      input.val(oldName)
      this.hideEditTaskName(input, taskId)
      return
    }

    if (newName === oldName) {
      this.hideEditTaskName(input, taskId)
      return
    }

    const url = Routes.owner_project_task_update_task_name_path(projectId, taskId)
    Shared.callAjax(url, { name: newName }).done(() => {
      $(`.task-name-link-${taskId}`).text(newName)
      $(`#modalSelectStatus-${taskId}`).find('.text-ellipsis.max-width-240px').text(newName)
      $(`#modalMenu-${taskId}`).find('.text-ellipsis.max-width-240px').text(newName)
      $(`.task-name-link-${taskId}`).each(function() {
        const currentWrapper = $(this).closest('.task-name-editable')
        currentWrapper.find('.input-task-text-name')
          .val(newName)
          .attr('value', newName)
          .data('origin-name', newName)
          .attr('data-origin-name', newName)
      })
    }).fail((data) => {
      let message = 'エラーが発生しました。再度確認してください。'
      if (data.responseJSON && data.responseJSON.message) message = data.responseJSON.message
      Popup.confirm(message, {
        confirmText: 'OK',
        cancelBtn: 'false',
        success: () => {},
        cancel: () => {},
      })
    })

    this.hideEditTaskName(input, taskId)
  }

  showEditTaskName(ele, taskId, projectId) {
    $(ele).parent().find(`.task-name-link-${taskId}`).addClass('d-none')
    $(ele).addClass('d-none')

    const nameInput = $(ele).parent().find('.input-task-text-name')
    const editBackdrop = $(ele).parent().find('.edit-task-name-backdrop')
    nameInput.removeClass('d-none')
    editBackdrop.removeClass('d-none')
    nameInput.trigger('focus').select()

    editBackdrop.off('click.taskThumb').on('click.taskThumb', () => {
      editBackdrop.off('click.taskThumb')
      this.handleChangeTaskName(nameInput, taskId, projectId)
    })

    nameInput.off('keydown.taskThumb').on('keydown.taskThumb', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault()
        this.handleChangeTaskName(nameInput, taskId, projectId)
      }
      if (e.key === 'Escape') {
        e.preventDefault()
        nameInput.val(nameInput.data('origin-name'))
        this.hideEditTaskName(nameInput, taskId)
      }
    })
  }

  saveTaskName(ele, taskId, projectId) {
    if (!$(ele).val()) {
      Popup.alert('タスク名を入力してください。')
      return
    }
    const url = Routes.owner_project_task_update_task_name_path(projectId, taskId)
    Shared.callAjax(url, { name: $(ele).val() }).done((data) => {
      Shared.reloadPage();
    }).fail((data) => {
      let message = 'エラーが発生しました。再度確認してください。'
      if (data.responseJSON && data.responseJSON.message) message = data.responseJSON.message
      Popup.confirm(message, {
        confirmText: 'OK',
        cancelBtn: 'false',
        success: () => { Shared.reloadPage() },
        cancel: () => { Shared.reloadPage() },
      });
    })
  }

  openEditTaskNameModal() {
    const taskName = $('#afterCreateTaskProjectModalFromTwoOptions').attr('data-task-name')
    $('#afterCreateTaskProjectModalFromTwoOptions').attr('data-transitioning-to-child', 'true')
    $('#afterCreateTaskProjectModalFromTwoOptions').modal('hide')
    $('#editTaskNameAfterCreateFromProjectList').attr('data-tm-parent-modal-id', 'afterCreateTaskProjectModalFromTwoOptions')
    $('#editTaskNameAfterCreateFromProjectList').attr('data-return-to-after-create', 'true')
    $('#editTaskNameAfterCreateFromProjectList').find('.edit-task-name-input').val(taskName)
    $('#editTaskNameAfterCreateFromProjectList').modal('show')
  }

  backToModalAfterCreateTask() {
    $('#editTaskNameAfterCreateFromProjectList').attr('data-return-to-after-create', 'false')
    $('#editTaskNameAfterCreateFromProjectList').modal('hide')
    $('#afterCreateTaskProjectModalFromTwoOptions').attr('data-transitioning-to-child', 'false')
    $('#afterCreateTaskProjectModalFromTwoOptions').removeAttr('data-tm-parent-modal-id')
    $('#afterCreateTaskProjectModalFromTwoOptions').modal('show')
    this.syncAfterCreateTaskModalBackStack()
  }

  saveTaskNameFromProjectList() {
    const taskId = $('#editTaskNameAfterCreateFromProjectList').attr('data-task-id')
    const projectId = $('#editTaskNameAfterCreateFromProjectList').attr('data-project-id')
    const input = $('.edit-task-name-input')
    if (!input.val()) {
      Popup.alert('タスク名を入力してください。')
      return
    }
    const url = Routes.owner_project_task_update_task_name_path(projectId, taskId)
    Shared.callAjax(url, { name: input.val() }).done((data) => {
      $('#afterCreateTaskProjectModalFromTwoOptions').find('.show-task-name').text(input.val())
      $(`.task-name-link-${taskId}`).text(input.val())
      $('#afterCreateTaskProjectModalFromTwoOptions').attr('data-task-name', input.val())
      $('#editTaskNameAfterCreateFromProjectList').attr('data-return-to-after-create', 'false')
      $('#editTaskNameAfterCreateFromProjectList').modal('hide')
      $('#afterCreateTaskProjectModalFromTwoOptions').attr('data-transitioning-to-child', 'false')
      $('#afterCreateTaskProjectModalFromTwoOptions').removeAttr('data-tm-parent-modal-id')
      $('#afterCreateTaskProjectModalFromTwoOptions').modal('show')
      this.syncAfterCreateTaskModalBackStack()
    }).fail((data) => {
      let message = I18n.t('shared.one_error_please_try_again')
      if (data.responseJSON && data.responseJSON.message) message = data.responseJSON.message
      Popup.confirm(message, {
        confirmText: 'OK',
        cancelBtn: 'false',
        success: () => { Shared.reloadPage() },
        cancel: () => { Shared.reloadPage() },
      });
    })
  }

  setupAfterCreateTaskModalFlow() {
    const task = this
    const afterCreateModal = $('#afterCreateTaskProjectModalFromTwoOptions')
    const editTaskNameModal = $('#editTaskNameAfterCreateFromProjectList')
    const memberModal = $('#personInChargeOfObject')

    afterCreateModal.off('shown.bs.modal.afterCreateTaskFlow').on('shown.bs.modal.afterCreateTaskFlow', function() {
      $('.modal-backdrop').off('click.afterCreateTaskFlow').on('click.afterCreateTaskFlow', function(event) {
        event.preventDefault()
        event.stopPropagation()
        task.closeAfterCreateTaskModal()
      })
    })

    afterCreateModal.off('click.afterCreateTaskFlow').on('click.afterCreateTaskFlow', function(event) {
      if (event.target !== this) return

      task.closeAfterCreateTaskModal()
    })

    afterCreateModal.off('hide.bs.modal.afterCreateTaskFlow').on('hide.bs.modal.afterCreateTaskFlow', function(event) {
      const isTransitioningToChild = $(this).attr('data-transitioning-to-child') == 'true'
      const isClosingAfterFinalize = $(this).attr('data-closing-after-finalize') == 'true'
      const isPendingMemberSetup = !$(this).find('.task-after-create-actions').hasClass('d-none')
      if (isTransitioningToChild || isClosingAfterFinalize || !isPendingMemberSetup) return

      event.preventDefault()
      task.closeAfterCreateTaskModal()
    })

    afterCreateModal.off('hidden.bs.modal.afterCreateTaskFlow').on('hidden.bs.modal.afterCreateTaskFlow', function() {
      const isTransitioningToChild = $(this).attr('data-transitioning-to-child') == 'true'
      if (isTransitioningToChild) return

      $('.modal-backdrop').off('click.afterCreateTaskFlow')
      $(this).attr('data-closing-after-finalize', 'false')
      $(this).attr('data-finalizing-before-close', 'false')
      $(this).removeAttr('data-tm-parent-modal-id')
      editTaskNameModal.removeAttr('data-tm-parent-modal-id')
      editTaskNameModal.attr('data-return-to-after-create', 'false')
      memberModal.off('hidden.bs.modal.returnAfterCreateTask')
      memberModal.removeAttr('data-tm-parent-modal-id')
      memberModal.attr('data-from-after-create-task', 'false')
      memberModal.attr('data-is-show', 'false')
      memberModal.removeClass('show').hide()
    })

    editTaskNameModal.off('hidden.bs.modal.afterCreateTaskFlow').on('hidden.bs.modal.afterCreateTaskFlow', function() {
      const shouldReturnToAfterCreate = $(this).attr('data-return-to-after-create') == 'true'
      if (!shouldReturnToAfterCreate) return

      $(this).attr('data-return-to-after-create', 'false')
      afterCreateModal.attr('data-transitioning-to-child', 'false')
      afterCreateModal.removeAttr('data-tm-parent-modal-id')
      afterCreateModal.modal('show')
      task.syncAfterCreateTaskModalBackStack()
    })
  }

  syncAfterCreateTaskModalBackStack() {
    const modalManager = window.AkaponCommonModalHeaderMaster
    const afterCreateModalId = 'afterCreateTaskProjectModalFromTwoOptions'
    if (!modalManager || !Array.isArray(modalManager.modalBackStack)) return

    modalManager.modalBackStack.length = 0
    modalManager.modalBackStack.push(
      { id: modalManager.MODAL_BACK_SENTINEL || '__NO_MODAL__' },
      { id: afterCreateModalId }
    )
  }

  colorPlanAkapon(){
    const plan_akapon = $('body').find('nav#navbar-common').data('plan-akapon');
    if (plan_akapon == 'undefined'){
      return '#202f55';
    }
    return plan_akapon ? '#E60C11' : '#202f55';
  }

  srollToLeftGrantChart(ele) {
    const componentShow = document.getElementById('GanttChartDIVgcharthead')
    const widthOfCol = document.getElementsByClassName('gtaskcell')[0].offsetWidth || 33;
    componentShow.scrollLeft -= widthOfCol;
    $('.div-show-scroll-for-grant-chart-right').show();
    if (componentShow.scrollLeft == 0) {
      $('.div-show-scroll-for-grant-chart-left').hide();
    }
  }

  srollToRightGrantChart(ele) {
    const componentShow = document.getElementById('GanttChartDIVgcharthead')
    const widthOfCol = document.getElementsByClassName('gtaskcell')[0].offsetWidth || 33;
    componentShow.scrollLeft += widthOfCol;
    var maxScrollLeft = componentShow.scrollWidth - componentShow.clientWidth;
    $('.div-show-scroll-for-grant-chart-left').show();
    if (maxScrollLeft == componentShow.scrollLeft) {
      $('.div-show-scroll-for-grant-chart-right').hide();
    }
  }

  closeAddPersonInChargeOfObject() {
    $('#addPersonInChargeOfObject').modal('hide')
    $('#personInChargeOfObject').modal('show')
  }

  backToMemberListModal() {
    setTimeout(() => {
      $('#personInChargeOfObject').modal('show')
      $('#addPersonInChargeOfObject').modal('hide')
      $('#personInChargeOfObject').find('.page-item[data-index="1"] .page-link').first()[0].click();
    }, 100)
  }

  removeNewAddWaiting(element, user_email) {
    const self = this;
    Popup.confirm(
      `${user_email}さんを解除します。<br> よろしいですか？`,
      {
        success: () => {
          self.showEleFilterNewAdd($(element).closest('.tr').closest('div'), false);
          $(element).closest('.tr.show-list-member-for-page').remove();
          Popup.alert(`${user_email}さんの招待を解除しました。`, '', '', {timer:3000, allowOutsideClick:false, allowEscapeKey:false})
        },
        cancel: () => {},
        confirmText: '解除する',
        cancelText: '後で行う',
        width: 'auto'
      }
    )
  }

  async showCheckList(popup_id, projectId){
    const isGrant = this.checkIsGrant()
    const url = Routes.checklists_owner_project_task_checklists_path(projectId)
    const modalCheckList = isGrant ? $(`#checkListModalGrant-${popup_id}`) : $(`#checkListModal-${popup_id}`)
    const self = this;
    const popupChat = $('#body-chat-show')
    if (popupChat.length > 0 && popupChat.find('.icon_chat_close').length > 0) {
      window._tmSilentChatClose = true
      popupChat.find('.icon_chat_close').trigger('click')
    }
    await Shared.callAjax(url, { task_id: popup_id }, 'html').done(function(data) {
      modalCheckList.find('#render_checklists').html(data)
      modalCheckList.modal('show')
      self._calculateCheckList(modalCheckList)
    })
  }

  checkIsGrant() {
    const params = new URLSearchParams(window.location.search);
    const isGrant = params.get('show_grant_chart')
    return isGrant && isGrant === 'true'
  }

  async addCheckList(btn_ele, taskId, projectId){
    let addItem = $(btn_ele).prevAll('.add_list').val()
    const url = Routes.owner_project_task_checklists_path(projectId)
    const self = this;
    const modalCheckList = self.checkIsGrant() ? $(`#checkListModalGrant-${taskId}`) : $(`#checkListModal-${taskId}`)
    if (addItem === '' || addItem === undefined) {
      Popup.alert('空白にはできません')
      return
    }
    await Shared.callAjax(url, { task_id: taskId, task_checklist: { name: addItem } }, 'html').done(function(data) {
      modalCheckList.find('#render_checklists').html(data)
      $(btn_ele).prevAll('.add_list').val('')
      self._calculateCheckList(modalCheckList)
    })
  }

  _calculateCheckList(popup_ele){
    // counting list item and change range level
    let listPopup = $(popup_ele)
    let listItems = listPopup.find('.lists').find('.list-item').not('.d-none')
    let listCountTotal = listItems.find('input').length
    let listCountChecked = listItems.find('input:checked').length
    let listRange = listPopup.find('.check_lists_range')
    let rangePersent = Math.ceil(100 / listCountTotal * listCountChecked)
    if(listCountTotal == 0) rangePersent = 0
    if(rangePersent > 100) rangePersent = 100
    listPopup.find('.display_persent').text(rangePersent)
    listRange.val(rangePersent)
    Disabled.toggle(listPopup.find('.c_list_delete_btn'), listPopup.find('input[type="checkbox"]').length === 0)
    const __lists = listPopup.find('.lists')
    if (__lists.length && typeof __lists.sortable === 'function') {
      if (__lists.hasClass('ui-sortable')) __lists.sortable('destroy')
      __lists.sortable({
        items: '> .list-item',
        axis: 'y',
        cancel: 'input,button,img,a,.show-name-checklist,.checkbox-for-checklist,.list-delete',
        cursor: 'grabbing'
      })
    }
  }

  async changeStatusCheckList(ele, taskId, checkListId, isFinish, projectId){
    const popup_obj = $(ele).closest('.modal')
    const url = Routes.change_status_owner_project_task_checklists_path(projectId)
    const self = this;
    await Shared.callAjax(
      url, { task_id: taskId, check_list_id: checkListId, is_finish: isFinish}, 'html'
    ).done(function(data) {
      if (['task_blank', 'check_list_blank', 'not_update'].includes(data)) {
        self._showPopupWhenNotFoundCheckList()
        return
      } else if (data === 'changed_reload') {
        Popup.confirm(I18n.t('work.changed_refresh'), {
          cancelBtn: 'false',
          success: () => { location.reload() },
          cancel: () => { location.reload() },
          confirmText: 'OK',
          width: 'auto'
        })
        return
      }
      popup_obj.find('#render_checklists').html(data)
      self._calculateCheckList(popup_obj)
    })
  }

  _showPopupWhenNotFoundCheckList() {
    Popup.confirm(I18n.t('work.not_check_list'), {
      cancelBtn: 'false',
      success: () => { Shared.reloadCurrentPage() },
      cancel: () => { Shared.reloadCurrentPage() },
      confirmText: 'OK',
      width: 'auto'
    })
  }

  changeChecklistName(ele, checkListId, taskId, projectId) {
    const newCheckListName = $(`#modal-show-change-checklist-${checkListId}`).find('input').val().trim()
    if (!newCheckListName) {
      Popup.alert('空白にはできません')
      return
    }
    const self = this;
    const modalCheckList = self.checkIsGrant() ? $(`#checkListModalGrant-${taskId}`) : $(`#checkListModal-${taskId}`)
    const url = Routes.change_name_owner_project_task_checklists_path(projectId)
    Shared.callAjax(url, {
      task_id: taskId,
      check_list_id: checkListId,
      name: newCheckListName,
    }, 'html').done(function(data) {
      if (data === 'not_changed') {
        Popup.confirm(I18n.t('work.not_check_list'), {
          cancelBtn: 'false',
          success: () => { Shared.reloadCurrentPage() },
          cancel: () => { Shared.reloadCurrentPage() },
          confirmText: 'OK',
          width: 'auto'
        })
        return
      }
      modalCheckList.find('#render_checklists').html(data)
      self._calculateCheckList(modalCheckList)
      $(`#modal-show-change-checklist-${checkListId}`).modal('hide')
      const modalBacDrop = $('body').find('div.modal-backdrop').length
      if (modalBacDrop > 1) {
        $('body').find('div.modal-backdrop:last').remove()
      }
    })
  }

  showChatCheckList(checkListId) {
    const self = this
    const modelChat = $(`#show-modal-select-list-qa-${checkListId}`)
    if (modelChat.length > 0) {
      Shared.showModalForElement(`#show-modal-select-list-qa-${checkListId}`)
    } else {
      self._showPopupWhenNotFoundCheckList()
    }
  }

  showListQaOfCheckList(checkListId, taskId, projectId) {
    const url = Routes.messages_of_checklist_owner_project_task_checklists_path(projectId)
    Shared.callAjax(url, { task_id: taskId, check_list_id: checkListId }, 'html').done(function(data) {
      if (['work_blank', 'check_list_blank'].includes(data)) {
        Popup.alert(I18n.t('work.not_check_list'))
        return
      }
      if (data === 'message_blank') {
        Popup.alert('このアイテムに関する投稿がありません。')
        return
      }
      Popup.contentModal(data, { title: 'トーク履歴' })
    })
  }

  deleteCheckListAll(btn_del_all, taskId, projectId){
    const self = this
    Popup.confirm(`${I18n.t('work.do_you_want_remove_all_checklist')}`, {
      success: () => { self._removeAllCheckList(btn_del_all, taskId, projectId) },
      confirmText: '削除する',
      width: 'auto',
    })
  }

  _removeAllCheckList(btn_del_all, taskId, projectId) {
    const url = Routes.delete_all_checklists_owner_project_task_checklists_path(projectId)
    const self = this
    Shared.callAjax(url, { task_id: taskId }).done(function(response) {
      let listPopup = $(btn_del_all).closest('.modal')
      listPopup.find('.lists').find('.list-item').not('.d-none').remove()
      self._calculateCheckList(listPopup)
    })
    .fail(function(response) {
      Popup.alert(I18n.t('shared.one_error_please_try_again'))
    })
  }

  deleteCheckList(btn_del, taskId, checkListId, projectId){
    let listPopup = $(btn_del).closest('.modal')
    const self = this
    Popup.confirm(I18n.t('work.remove_check_list'), {
      success: () => {
        self.handleRemoveCheckList(listPopup, taskId, checkListId, projectId)
      },
      cancelBtn: 'false',
      confirmText: '削除する',
      width: 'auto',
      closeOnOverlay: true,
    })
  }

  handleRemoveCheckList(listPopup, taskId, checkListId, projectId) {
    const url = Routes.delete_checklist_owner_project_task_checklists_path(projectId)
    const self = this
    Shared.callAjax(url, { task_id: taskId, check_list_id: checkListId }, 'html').done(function(data) {
      if (['task_blank', 'check_list_blank', 'not_delete'].includes(data)) {
        self._showPopupWhenNotFoundCheckList()
        return
      }
      listPopup.find('#render_checklists').html(data)
      self._calculateCheckList(listPopup)
    })
  }

  refreshTaskListAfterCreate(projectId, taskId) {
    const taskTable = $('#task-table');
    const taskExpirationModalsContainer = $('#dynamic-task-expiration-modals');
    if (!taskTable.length) return;

    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('is_render_new_task_list', 'true');
    currentUrl.searchParams.set('new_task', 'true');
    currentUrl.searchParams.set('task_id', taskId);

    Shared.callAjax(currentUrl.toString(), {}, 'json', 'GET', false)
      .done((result) => {
        if (result.task_list_html) {
          taskTable.html(result.task_list_html);
          if (taskExpirationModalsContainer.length && result.task_expiration_modal_html) {
            taskExpirationModalsContainer.find(`#modal_expiration_task_${taskId}`).remove()
            taskExpirationModalsContainer.append(result.task_expiration_modal_html)
            if (window.defaultAction && typeof window.defaultAction.runDatepicker === 'function') {
              window.defaultAction.runDatepicker()
            }
          }
          this._initializeTaskSortable();
          this.highlightTaskNameAfterCreate(taskId);
        }
      })
      .fail(() => {
        Popup.alert(I18n.t('shared.one_error_please_try_again'))
      });
  }

  highlightTaskNameAfterCreate(taskId) {
    const taskLinks = $(`.task-name-link-${taskId}`);

    taskLinks.removeClass('text-primary').addClass('text-red font-weight-bold');

    const firstTaskLink = taskLinks.first();
    if (firstTaskLink.length > 0) {
      firstTaskLink[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  _initializeTaskSortable() {
    const tbodyListTask = $('#tbody-list-task');
    if (!tbodyListTask.length || !$.fn.sortable) return;

    if (tbodyListTask.data('ui-sortable')) {
      tbodyListTask.sortable('destroy');
    }

    tbodyListTask.sortable({
      cursor: 'grabbing',
      items: '.parent_row',
      update: function(event, ui) {
        const trId = ui.item.attr('id');
        const cloneTr = $(`tr.ancestory_row.${trId}`).clone();
        $(`tr.ancestory_row.${trId}`).remove();
        cloneTr.insertAfter(`#${trId}`);

        if (tbodyListTask.attr('data-sort-default') == 'true') {
          // 行移動時のカスタマイズ並び順案内モーダルは表示しない
          // if (!gon.tasks_feature.is_not_show_popup_custom_sort) {
          //   if ($('#notifyChangeSortProject').attr('data-show-notify') != 'true') {
          //     Shared.showModalForElement($('#notifyChangeSortProject'));
          //   }
          // }
        } else {
          const url = Routes.object_sort_path(tbodyListTask.attr('data-sort-id'));
          const sortFunction = new SortFunction();
          let dataSort = sortFunction.listDataSortTask();
          Shared.callAjax(url, {data_sort: dataSort, type: 'task', object_id: projectId}, 'json', 'patch');
        }
      }
    });
  }
}
